<template>

  <Head>
    <title>Add Menu Week | NutriStudents K-12</title>
    <meta name="description" content="Add Menu Week">
  </Head>
  <default-layout>

    <form action="#" @submit.prevent="false">
      <PageTitleLayout>
        <div class="w-full flex lg:flex-nowrap flex-wrap justify-end items-center pt-10">
          <div class="w-full mr-auto">
            <h1 class="heading-color xl:text-3xl text-2xl font-bold">{{ menuName }}</h1>

          </div>
          <div class="flex lg:flex-nowrap flex-wrap lg:justify-end md:justify-end justify-start">
            <button v-if="(this.guide_line_id != '' && this.guide_line_id != null)"
              @click="changeMonthYearModalOpen()"
              class="md:w-60 w-full button-color text-white font-bold py-3 rounded md:mt-0 mt-4 px-4 md:mr-2 ml-0 leading-4 uppercase">Save
              as New Menu Week</button>
            <div>
              <inertia-link v-if="this.offering_id != ''" :href="$page.props.site_url +
                                '/menu-planner' +
                                '?month=' +
                                month +
                                '&year=' +
                                year +
                                '&type=' +
                                type +
                                '&site=' +
                                form.site +
                                '&guide_line_id=' +
                                form.guideline_id +
                                '&offering_id=' +
                                form.offering_id
                                "
                class="md:w-24 w-full button-color text-white font-bold py-3 rounded lg:mt-0 sm:mt-4 px-4 cancel-background-color leading-4 inline-block">CANCEL
              </inertia-link>
              <inertia-link v-if="this.offering_id === ''" :href="route('week-cycles')"
                class="md:w-24 w-full button-color text-white font-bold py-3 rounded lg:mt-0 sm:mt-4 px-4 cancel-background-color max-w-max inline-block leading-4">
                CANCEL
              </inertia-link>
            </div>

            <button type="submit" @click="menucycle_add_save_script"
              class="md:w-24 w-full button-color text-white font-bold py-3 rounded md:mt-0 mt-4 px-4 md:ml-2 ml-0 leading-4">SAVE</button>
          </div>
        </div>
      </PageTitleLayout>

      <PageTitleLayout v-if="(this.guide_line_id === '' || this.guide_line_id === null)">
        <div class="w-full pt-4 pb-8 mt-4  bg-white white-shadow-box">
          <div class="flex lg:flex-nowrap flex-wrap  items-center w-full">
            <div class="flex mt-6 ml-4  md:w-40 w-full font-bold">
              <label>Name*</label>
            </div>
            <div class="flex mt-4 ml-4 lg:w-4/5 md:w-3/5 w-full">
              <div class="relative focus:outline-none md:w-3/5 w-full mr-3 xl:mt-0 md:ml-2 ml-0">
                <input type="text" placeholder="Week1" id="mc_name" name="mc_name"
                  v-model="form.mc_name"
                  class="w-full shadow-sm focus:border-none block sm:text-sm border-gray-300  rounded-lg w-full select-menu-height input-background">
                <div v-if="form.errors.mc_name" class="validation_error_msg">{{ form.errors.mc_name }}
                </div>
              </div>
            </div>
          </div>

          <div class="flex lg:flex-nowrap flex-wrap  items-center w-full">
            <div class="flex mt-6 ml-4  md:w-40 w-full font-bold">
              <label>Week Number</label>
            </div>
            <div class="flex mt-4 ml-4 lg:w-4/5 md:w-3/5 w-full">
              <div class="relative focus:outline-none md:w-3/5 w-full mr-3 xl:mt-0 md:ml-2 ml-0">
                <input type="number" min="0" placeholder="Week number" v-model="form.week_number"
                  class="w-full shadow-sm focus:border-none block sm:text-sm border-gray-300  rounded-lg w-full select-menu-height input-background">
                <div v-if="form.errors.week_number" class="validation_error_msg">{{
                                    form.errors.week_number
                                }}</div>
              </div>
            </div>
          </div>

          <div class="flex lg:flex-nowrap flex-wrap ">
            <div class="flex mt-6 ml-4 md:w-40 w-full font-bold">
              <label class="">Meal Type*</label>
            </div>
            <div class="flex mt-4 ml-4 lg:w-56 md:w-40 w-full">
              <div class="relative focus:outline-none lg:w-56 md:w-40 w-full mr-3 xl:mt-0 md:ml-2 ml-0">
                <select :disabled="!is_fav_show ? true : false" id="meal_type_id" name="meal_type_id"
                  v-model="form.meal_type_id"
                  class="input-background shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
                  @change="updateGuidelineValues">
                  <option value="">Select</option>
                  <option v-for="mealVal in mealtype_data" :value="mealVal.id">{{ mealVal.name }}
                  </option>
                </select>
                <div
                  class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
                <div v-if="form.errors.meal_type_id" class="validation_error_msg">{{
                                    form.errors.meal_type_id }}</div>
              </div>
            </div>
          </div>

          <div class="flex lg:flex-nowrap flex-wrap ">
            <div class="flex mt-6 ml-4 md:w-40 w-full font-bold">
              <label class="">Age Range*</label>
            </div>
            <div class="flex mt-4 ml-4 lg:w-56 md:w-40 w-full">
              <div class="relative focus:outline-none lg:w-56 md:w-40 w-full mr-3 xl:mt-0 md:ml-2 ml-0">

                <select :disabled="!is_fav_show ? true : false" id="age_grade_id" name="age_grade_id"
                  v-model="form.age_grade_id"
                  class="input-background shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
                  @change="updateGuidelineValues">
                  <option value="">Select</option>
                  <option v-for="ageVal in agerange_data" :value="ageVal.id">{{ ageVal.name }}
                  </option>
                </select>
                <div
                  class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
                <div v-if="form.errors.age_grade_id" class="validation_error_msg">{{
                                    form.errors.age_grade_id }}</div>
              </div>
            </div>
          </div>

          <div class="flex lg:flex-nowrap flex-wrap ">
            <div class="flex mt-6 ml-4 md:w-40 w-full font-bold">
              <label class="">Days*</label>
            </div>
            <div class="flex mt-4 ml-4 lg:w-56 md:w-40 w-full">
              <div class="relative focus:outline-none lg:w-56 md:w-40 w-full mr-3 xl:mt-0 md:ml-2 ml-0">
                <select :disabled="!is_fav_show ? true : false" id="days_id" name="days_id"
                  v-model="form.days_id"
                  class="input-background shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
                  @change="updateGuidelineValues">
                  <option value="">Select</option>
                  <option v-for="daysVal in days_data" :value="daysVal.id">{{ daysVal.name }}</option>
                </select>
                <div
                  class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
                <div v-if="form.errors.days_id" class="validation_error_msg">{{ form.errors.days_id }}
                </div>
              </div>
            </div>
          </div>

          <div class="flex lg:flex-nowrap flex-wrap  items-center w-full">
            <div class="flex mt-6 ml-4 md:w-40 w-full font-bold">
              <label>Guideline*</label>
            </div>
            <div class="flex mt-4 ml-4 lg:w-56 md:w-40 w-full">
              <div class="relative focus:outline-none lg:w-56 md:w-40 w-full mr-3 xl:mt-0 md:ml-2 ml-0">

                <select :disabled="!is_fav_show ? true : false" id="guideline" name="guideline_id"
                  class="input-background shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
                  v-model="form.guideline_id" @change="getComponentTotalsAsPerOffering($event)">
                  <option value="">Select</option>
                  <option v-for="(guideline, index) in guidelines" :value="guideline.id">
                    {{ guideline.name }}
                  </option>
                </select>
                <div
                  class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>

                <div v-if="form.errors.guideline_id" class="validation_error_msg">{{
                                    form.errors.guideline_id }}</div>
              </div>
            </div>
          </div>

          <div v-if="this.guide_line_id != null"
            class="flex lg:flex-nowrap flex-wrap font-bold items-center w-full">
            <div class="flex mt-6 ml-4 md:w-40 w-full">
              <label>Save This for Future</label>
            </div>
            <div class="flex mt-4 ml-4 lg:w-56 md:w-40 w-full">
              <div class="relative focus:outline-none lg:w-56 md:w-40 w-full mr-3 xl:mt-0 md:ml-2 ml-0">
                <input type="checkbox"
                  class="w-5 h-5 appearance-none checked:bg-blue-600 rounded-sm bg-gray-100 border-gray-300 focus:ring-0 focus:ring-offset-0 cursor-pointer"
                  v-model="form.is_template">

              </div>
            </div>
          </div>

        </div>

      </PageTitleLayout>

      <!-- <PageTitleLayout>
          <div class="w-full pt-4 mt-4 pb-4 mb-4 font-bold bg-white white-shadow-box">

         </div>
         </PageTitleLayout> -->

      <WeeklyCalculatedTotals :getAllRecipes="getAllRecipes" :guideline_data="guideline_data"
        :mc_weekly_avg_prods="mc_weekly_avg_prods" :weeklyAvg="weeklyAvg" :null_nutrient="null_nutrient"
        :override_components="override_components" />

      <!-- Week Days starts from here... -->

      <div class="w-full xl:px-10 px-5 pb-10 overflow-x-auto" @click="autoSelectInputOnClick">
        <div class="flex flex-nowrap pt-0 pb-10 overflow-x-auto items-start">

          <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">
            <header
              class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">
              <div class="left_coll flex gap-2 items-center">
                <h2 class="text-white text-lg font-bold cursor-pointer w-full"
                  :title="$helpers.getByName(mc_daily_sum_prod_mon)">Monday</h2>
                <div style="z-index: 1; " class="h-[20px]">
                  <i v-show="showWarningHover(mc_daily_sum_prod_mon, mc_final_options_mon).length > 0 && getAllDay.includes('mon')"
                    v-on:mouseover="showMonAdditional = true"
                    v-on:mouseleave="showMonAdditional = false"
                    class="fa fa-exclamation-circle bg-white rounded-full text-[#cb0000] mr-auto text-lg "
                    style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
                  <ul v-show="showMonAdditional" class="absolute bg-white p-4 ml-4"
                    style="border-radius: 0px 10px 10px 10px;">
                    <li v-for="additional in showWarningHover(mc_daily_sum_prod_mon, mc_final_options_mon)"
                      class="block text-black text-sm list-disc pb-1">
                      {{ additional }}
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="total_planned_number_mon > 0 && mc_final_options_mon.length > 0" class="w-14">
                <input type="number"
                  class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
                  v-model="total_planned_number_mon" :disabled="true">
              </div>

              <div class="right_coll">
                <a href="#" @click="addRecipeOptionMenuCycle(1)">
                  <i class="fa fa-plus text-white pt-2 pr-2" aria-hidden="true"></i>
                </a>
              </div>
              <!-- <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white pt-2 pr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"/>
      </svg> -->

            </header>

            <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_mon" />

            <div v-if="!mc_final_options_mon.length"
              class="w-full flex flex-wrap items-center justify-center py-4">
              <div>
                <div class="text-center pl-8">
                  <img
                    :src="$page.props.asset_url + '/vendor/nutristudents/image/food-img/_Path_.png'">
                </div>
                <p class="pt-4 pl-2">Nothing Here Yet</p>
                <a href="#" @click="addRecipeOptionMenuCycle(1)" class="underline text-center block">Add
                  A
                  Menu Option</a>
                <button v-if="copied_option_data" type="button"
                  @click="addOptionPasteScript(mc_final_options_mon.length, 1)"
                  class="underline text-center block">Paste Menu Option</button>
              </div>
            </div>

            <draggable class="list-group" :list="mc_final_options_mon" group="menus"
              @change="event => handleDrag(event, 1)">
              <template #item="{ element, index }">
                <div class="px-4 py-4 group/main">
                  <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item " @mouseover="showAddIcon = true"
                    @mouseleave="showAddIcon = false">
                    <ul>
                      <li class="flex flex-wrap justify-between pb-4 relative uppercase ">
                        <div class="w-full flex flex-nowrap">
                          <div class=" flex w-full flex-nowrap">

                            <div :title="$helpers.getByName(element.new_total_val)"
                              class="cursor-pointer max-w-[60%]  w-full">{{ element.name
                              }}
                            </div>
                            <span class="cursor-pointer pr-1 is_hide_production" @click="openTagPopup(element, index, 'mon')">
                              <img :src="$page.props.asset_url + '/images/download.svg'" class="w-6">
                            </span>
                          </div>



                          <input @change="changePlannedNumberValue(element, 'mon')" type="number"
                            v-model="element.planned_number"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
                            autocomplete="off">

                          <div class="">
                            <MenuOption 
                              @messageFromChildEdit="addOptionEditScript(element, index, 1)"
                              @messageFromChildCopy="addOptionCopyScript(element)"
                              @messageFromChildPaste="addOptionPasteScript(mc_final_options_mon.length, 1)"
                              @messageFromChildDuplicate="addOptionDuplicateScript(element, mc_final_options_mon.length, 1)"
                              @messageFromChildDelete="addOptionDeleteScript(index, 1)"
                              @sendToAllReceives="sendToAllReceives(element)" />
                          </div>
                        </div>

                        <ListOptionTag :element="element" :default_tag="default_tag" @removeTag="removeTag" :shared_letters="shared_letters" :day_tag="day_tags['mon']" />


                      </li>


                      <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                        v-show="checkRecipeExist( mc_option_recipe, getRecipeArray(element.recipes, mc_final_options_mon).allRecipe)"
                        class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                        :title="$helpers.getByName(mc_option_recipe.total_val)">
                        <div class="flex gap-2 w-full justify-between group"
                          mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                          mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                          <div class="text-sm font-bold text-color-first-li">

                            <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                              {{ mc_option_recipe.name }}
                            </a>
                          </div>
                          <div>
                            <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                              <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                                $helpers.getByFirstName(mc_option_recipe.total_val)
                                }}</span>
                            </div>
                            <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                              <svg xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                fill="currentColor" @click="is_show = !is_show"
                                if="hoveredIndex === mc_option_recipe.id + element.id">
                                <path
                                  d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                              </svg>

                              <div v-if="is_show"
                                class="bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10">
                                <RecipeMenuOption
                                  @replaceOptionRecipe="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'mon')"
                                  @attachRecipeToDefaultTag="attachRecipeToDefaultTag(mc_final_options_mon, mc_option_recipe)"
                                  @detachRecipeToDefaultTag="detachRecipeToDefaultTag( mc_final_options_mon,mc_option_recipe)"
                                  @deleteOptionRecipeButton="deleteOptionRecipeButton(mc_option_recipe,element, 'mon', index, 1)"
                                  @detachRecipeToTag="detachRecipeToTag" @attachRecipeToTag="attachRecipeToTag"
                                  :mc_option_recipe="mc_option_recipe" :default_tag="default_tag" :element="element" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div v-if="getRecipeArray(element.recipes, mc_final_options_mon).collapsedRecipe.length > 0">
                      <div class="text-sm flex gap-1 items-center cursor-pointer"
                        @click="toggleCollapse('mon_collapse_'+index)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                          class="size-6 -ml-1 " :class="{ 'rotate-90': checkCollapse('mon_collapse_'+index)}">
                          <path fill-rule="evenodd"
                            d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                            clip-rule="evenodd" />
                        </svg>
                        <span>And {{ getRecipeArray(element.recipes, mc_final_options_mon).collapsedRecipe.length }}
                          other items</span>
                      </div>
                      <ul class="w-full mt-2" v-if="checkCollapse('mon_collapse_'+index)">
                        <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                          v-show="checkRecipeExist( mc_option_recipe, getRecipeArray(element.recipes, mc_final_options_mon).collapsedRecipe)"
                          class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                          :title="$helpers.getByName(mc_option_recipe.total_val)">
                          <div class="flex gap-2 w-full justify-between group"
                            mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                            mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                            <div class="text-sm font-bold text-color-first-li">
                              <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                                {{ mc_option_recipe.name }}
                              </a>
                            </div>
                            <div>
                              <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                                <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                                  $helpers.getByFirstName(mc_option_recipe.total_val)
                                  }}</span>
                              </div>
                              <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                  class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                  fill="currentColor" @click="is_show = !is_show"
                                  if="hoveredIndex === mc_option_recipe.id + element.id">
                                  <path
                                    d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                </svg>

                                <div v-if="is_show"
                                  class="bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10">
                                  <RecipeMenuOption
                                    @replaceOptionRecipe="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'mon')"
                                    @attachRecipeToDefaultTag="attachRecipeToDefaultTag(mc_final_options_mon, mc_option_recipe)"
                                    @detachRecipeToDefaultTag="detachRecipeToDefaultTag( mc_final_options_mon,mc_option_recipe)"
                                    @deleteOptionRecipeButton="deleteOptionRecipeButton(mc_option_recipe,element, 'mon', index, 1)"
                                    @detachRecipeToTag="detachRecipeToTag" @attachRecipeToTag="attachRecipeToTag"
                                    :mc_option_recipe="mc_option_recipe" :default_tag="default_tag"
                                    :element="element" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div class="hidden group-hover/main:block text-bold">
                      <AddRecipe :element="element" :index="index" :day="'mon'" @makeAddRecipe="makeAddRecipe" />
                    </div>
                  </div>
                </div>
              </template>
            </draggable>
            <ListTag :mc_final_options="mc_final_options_mon" @sendRecipe="sendRecipe" :default_tag="default_tag" :shared_letters="shared_letters" :day_tag="day_tags['mon']" />

          </div>

          <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">

            <header
              class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">
              <div class="left_coll flex gap-2 items-center">
                <h2 class="text-white text-lg font-bold cursor-pointer  w-full"
                  :title="$helpers.getByName(mc_daily_sum_prod_tue)">Tuesday</h2>

                <div class="h-[20px]" style="z-index: 1;">
                  <i v-show="showWarningHover(mc_daily_sum_prod_tue, mc_final_options_tue).length > 0 && getAllDay.includes('tue')"
                    v-on:mouseover="showTueAdditional = true"
                    v-on:mouseleave="showTueAdditional = false"
                    class="fa fa-exclamation-circle text-[#cb0000] mr-auto text-lg bg-white rounded-full "
                    style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
                  <ul v-show="showTueAdditional" class="absolute bg-white p-4 ml-4"
                    style="border-radius: 0px 10px 10px 10px;">
                    <li class="block text-black text-sm list-disc pb-1"
                      v-for="additional in showWarningHover(mc_daily_sum_prod_tue, mc_final_options_tue)">
                      {{ additional }}
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="total_planned_number_tue > 0 && mc_final_options_tue.length > 0" class="w-14">
                <input type="number"
                  class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
                  v-model="total_planned_number_tue" :disabled="true">
              </div>
              <div class="right_coll">
                <a href="#" @click="addRecipeOptionMenuCycle(2)">
                  <i class="fa fa-plus text-white pt-2 pr-2" aria-hidden="true"></i>
                </a>
              </div>
            </header>

            <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_tue" />

            <div v-if="!mc_final_options_tue.length"
              class="w-full flex flex-wrap items-center justify-center py-4">
              <div>
                <div class="text-center pl-8">
                  <img
                    :src="$page.props.asset_url + '/vendor/nutristudents/image/food-img/_Path_.png'">
                </div>
                <p class="pt-4 pl-2">Nothing Here Yet</p>
                <a href="#" @click="addRecipeOptionMenuCycle(2)" class="underline text-center block">Add
                  A
                  Menu Option</a>
                <button v-if="copied_option_data" type="button"
                  @click="addOptionPasteScript(mc_final_options_tue.length, 2)"
                  class="underline text-center block">Paste
                  Menu Option</button>
              </div>
            </div>

            <draggable class="list-group" :list="mc_final_options_tue" group="menus"
              @change="event => handleDrag(event, 2)">
              <template #item="{ element, index }">
                <div class="px-4 py-4 group/main">
                  <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item">
                    <ul>
                      <li class="flex flex-wrap justify-between pb-4 relative uppercase">
                        <!-- <div :title="$helpers.getByName(element.new_total_val)"
                                                    class="cursor-pointer max-w-[60%]">{{ element.name }}</div> -->
                        <div class="w-full flex flex-nowrap">
                          <div class="flex w-full ">
                            <div :title="$helpers.getByName(element.new_total_val)"
                              class="cursor-pointer max-w-[60%] w-full">{{ element.name }}
                            </div>

                            <span class="cursor-pointer pr-1 is_hide_production" @click="openTagPopup(element, index, 'tue')">
                              <img :src="$page.props.asset_url + '/images/download.svg'" class="w-6">
                            </span>

                          </div>
                          <input @change="changePlannedNumberValue(element, 'tue')" type="number"
                            v-model="element.planned_number"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden">

                          <div>
                            <MenuOption 
                              @messageFromChildEdit="addOptionEditScript(element, index, 2)"
                              @messageFromChildCopy="addOptionCopyScript(element)"
                              @messageFromChildPaste="addOptionPasteScript(mc_final_options_tue.length, 2)"
                              @messageFromChildDuplicate="addOptionDuplicateScript(element, mc_final_options_tue.length, 2)"
                              @messageFromChildDelete="addOptionDeleteScript(index, 2)"
                              @sendToAllReceives="sendToAllReceives(element)" />
                          </div>
                        </div>
                        <ListOptionTag :element="element" :default_tag="default_tag" @removeTag="removeTag" :shared_letters="shared_letters" :day_tag="day_tags['tue']" />

                      </li>
                      <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                        v-show="checkRecipeExist( mc_option_recipe, getRecipeArray(element.recipes, mc_final_options_tue).allRecipe)"
                        class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                        :title="$helpers.getByName(mc_option_recipe.total_val)">
                        <div class="flex gap-2 w-full justify-between group"
                          mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                          mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                          <div class="text-sm font-bold text-color-first-li">
                            <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                              {{ mc_option_recipe.name }}
                            </a>
                          </div>
                          <div>
                            <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                              <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                                $helpers.getByFirstName(mc_option_recipe.total_val)
                                }}</span>
                            </div>
                            <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                              <svg xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                fill="currentColor" @click="is_show = !is_show"
                                if="hoveredIndex === mc_option_recipe.id + element.id">
                                <path
                                  d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                              </svg>

                              <div v-if="is_show" class="
                                                            bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10 
                                                            ">

                                <RecipeMenuOption
                                  @replaceOptionRecipe="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'tue')"
                                  @attachRecipeToDefaultTag="attachRecipeToDefaultTag(mc_final_options_tue, mc_option_recipe)"
                                  @detachRecipeToDefaultTag="detachRecipeToDefaultTag( mc_final_options_tue,mc_option_recipe)"
                                  @deleteOptionRecipeButton="deleteOptionRecipeButton(mc_option_recipe,element, 'tue', index, 2)"
                                  @detachRecipeToTag="detachRecipeToTag" @attachRecipeToTag="attachRecipeToTag"
                                  :mc_option_recipe="mc_option_recipe" :default_tag="default_tag" :element="element" />

                              </div>
                            </div>
                          </div>
                        </div>

                      </li>
                    </ul>

                    <div v-if="getRecipeArray(element.recipes, mc_final_options_tue).collapsedRecipe.length > 0">
                      <div class="text-sm flex gap-1 items-center cursor-pointer"
                        @click="toggleCollapse('tue_collapse_'+index)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                          class="size-6 -ml-1 " :class="{ 'rotate-90': checkCollapse('tue_collapse_'+index)}">
                          <path fill-rule="evenodd"
                            d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                            clip-rule="evenodd" />
                        </svg>
                        <span>And {{ getRecipeArray(element.recipes, mc_final_options_tue).collapsedRecipe.length }}
                          other items</span>
                      </div>
                      <ul class="w-full mt-2" v-if="checkCollapse('tue_collapse_'+index)">
                        <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                          v-show="checkRecipeExist( mc_option_recipe, getRecipeArray(element.recipes, mc_final_options_tue).collapsedRecipe)"
                          class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                          :title="$helpers.getByName(mc_option_recipe.total_val)">
                          <div class="flex gap-2 w-full justify-between group"
                            mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                            mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                            <div class="text-sm font-bold text-color-first-li">
                              <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                                {{ mc_option_recipe.name }}
                              </a>
                            </div>
                            <div>
                              <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                                <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                                  $helpers.getByFirstName(mc_option_recipe.total_val)
                                  }}</span>
                              </div>
                              <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                  class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                  fill="currentColor" @click="is_show = !is_show"
                                  if="hoveredIndex === mc_option_recipe.id + element.id">
                                  <path
                                    d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                </svg>

                                <div v-if="is_show"
                                  class="bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10">
                                  <RecipeMenuOption
                                    @replaceOptionRecipe="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'tue')"
                                    @attachRecipeToDefaultTag="attachRecipeToDefaultTag(mc_final_options_tue, mc_option_recipe)"
                                    @detachRecipeToDefaultTag="detachRecipeToDefaultTag( mc_final_options_tue,mc_option_recipe)"
                                    @deleteOptionRecipeButton="deleteOptionRecipeButton(mc_option_recipe,element, 'tue', index, 2)"
                                    @detachRecipeToTag="detachRecipeToTag" @attachRecipeToTag="attachRecipeToTag"
                                    :mc_option_recipe="mc_option_recipe" :default_tag="default_tag"
                                    :element="element" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div class="hidden group-hover/main:block text-bold">
                      <AddRecipe :element="element" :index="index" :day="'tue'" @makeAddRecipe="makeAddRecipe" />
                    </div>
                  </div>
                </div>
              </template>
            </draggable>

            <ListTag :mc_final_options="mc_final_options_tue" @sendRecipe="sendRecipe" :default_tag="default_tag" :shared_letters="shared_letters" :day_tag="day_tags['tue']" />

          </div>

          <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">

            <header
              class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">
              <div class="left_coll flex gap-2 items-center">
                <h2 class="text-white text-lg font-bold  cursor-pointer w-full"
                  :title="$helpers.getByName(mc_daily_sum_prod_wed)">Wednesday</h2>
                <div class="h-[20px]" style="z-index: 1;">
                  <i v-show="showWarningHover(mc_daily_sum_prod_wed, mc_final_options_wed).length > 0 && getAllDay.includes('wed')"
                    v-on:mouseover="showWebAdditional = true"
                    v-on:mouseleave="showWebAdditional = false"
                    class="fa fa-exclamation-circle bg-white rounded-full text-[#cb0000] mr-auto text-lg "
                    style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
                  <ul v-show="showWebAdditional" class="absolute bg-white p-4 ml-4"
                    style="border-radius: 0px 10px 10px 10px;">
                    <li class="block text-black text-sm list-disc pb-1"
                      v-for="additional in showWarningHover(mc_daily_sum_prod_wed, mc_final_options_wed)">
                      {{ additional }}
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="total_planned_number_wed > 0 && mc_final_options_wed.length > 0" class="w-14">
                <input type="number"
                  class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
                  v-model="total_planned_number_wed" :disabled="true">
              </div>
              <div class="right_coll">
                <a href="#" @click="addRecipeOptionMenuCycle(3)">
                  <i class="fa fa-plus text-white pt-2 pr-2" aria-hidden="true"></i>
                </a>
              </div>
            </header>

            <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_wed" />

            <div v-if="!mc_final_options_wed.length"
              class="w-full flex flex-wrap items-center justify-center py-4">
              <div>
                <div class="text-center pl-8">
                  <img
                    :src="$page.props.asset_url + '/vendor/nutristudents/image/food-img/_Path_.png'">
                </div>
                <p class="pt-4 pl-2">Nothing Here Yet</p>
                <a href="#" @click="addRecipeOptionMenuCycle(3)" class="underline text-center block">Add
                  A
                  Menu Option</a>
                <button v-if="copied_option_data" type="button"
                  @click="addOptionPasteScript(mc_final_options_wed.length, 3)"
                  class="underline text-center block">Paste
                  Menu Option</button>
              </div>
            </div>

            <draggable class="list-group" :list="mc_final_options_wed" group="menus"
              @change="event => handleDrag(event, 3)">
              <template #item="{ element, index }">
                <div class="px-4 py-4 group/main">
                  <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item">
                    <ul>
                      <li class="flex flex-wrap justify-between pb-4 relative uppercase">
                        <div class="w-full flex flex-nowrap">
                          <div class=" flex w-full">
                            <div :title="$helpers.getByName(element.new_total_val)"
                              class="cursor-pointer max-w-[60%] w-full">{{ element.name }}
                            </div>

                            <span class="cursor-pointer pr-1 is_hide_production" @click="openTagPopup(element, index, 'wed')">
                              <img :src="$page.props.asset_url + '/images/download.svg'" class="w-6">
                            </span>

                          </div>
                          <input @change="changePlannedNumberValue(element, 'wed')" type="number"
                            v-model="element.planned_number"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden">

                          <div>
                            <MenuOption 
                              @messageFromChildEdit="addOptionEditScript(element, index, 3)"
                              @messageFromChildCopy="addOptionCopyScript(element)"
                              @messageFromChildPaste="addOptionPasteScript(mc_final_options_wed.length, 3)"
                              @messageFromChildDuplicate="addOptionDuplicateScript(element, mc_final_options_wed.length, 3)"
                              @messageFromChildDelete="addOptionDeleteScript(index, 3)"
                              @sendToAllReceives="sendToAllReceives(element)" />
                          </div>
                        </div>
                        <ListOptionTag :element="element" :default_tag="default_tag" @removeTag="removeTag" :shared_letters="shared_letters" :day_tag="day_tags['wed']" />
                      </li>

                      <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                        v-show="checkRecipeExist( mc_option_recipe, getRecipeArray(element.recipes, mc_final_options_wed).allRecipe)"
                        class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                        :title="$helpers.getByName(mc_option_recipe.total_val)">

                        <div class="flex gap-2 w-full justify-between group"
                          mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                          mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                          <div class="text-sm font-bold text-color-first-li">
                            <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                              {{ mc_option_recipe.name }}
                            </a>
                          </div>
                          <div>
                            <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                              <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                                $helpers.getByFirstName(mc_option_recipe.total_val)
                                }}</span>
                            </div>
                            <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                              <svg xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                fill="currentColor" @click="is_show = !is_show"
                                if="hoveredIndex === mc_option_recipe.id + element.id">
                                <path
                                  d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                              </svg>

                              <div v-if="is_show" class="
                                                            bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10 
                                                            ">

                                <RecipeMenuOption
                                  @replaceOptionRecipe="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'wed')"
                                  @attachRecipeToDefaultTag="attachRecipeToDefaultTag(mc_final_options_wed, mc_option_recipe)"
                                  @detachRecipeToDefaultTag="detachRecipeToDefaultTag( mc_final_options_wed,mc_option_recipe)"
                                  @deleteOptionRecipeButton="deleteOptionRecipeButton(mc_option_recipe,element, 'wed', index, 3)"
                                  @detachRecipeToTag="detachRecipeToTag" @attachRecipeToTag="attachRecipeToTag"
                                  :mc_option_recipe="mc_option_recipe" :default_tag="default_tag" :element="element" />

                              </div>
                            </div>
                          </div>
                        </div>

                      </li>
                    </ul>

                    <div v-if="getRecipeArray(element.recipes, mc_final_options_wed).collapsedRecipe.length > 0">
                      <div class="text-sm flex gap-1 items-center cursor-pointer"
                        @click="toggleCollapse('wed_collapse_'+index)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                          class="size-6 -ml-1 " :class="{ 'rotate-90': checkCollapse('wed_collapse_'+index)}">
                          <path fill-rule="evenodd"
                            d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                            clip-rule="evenodd" />
                        </svg>
                        <span>And {{ getRecipeArray(element.recipes, mc_final_options_wed).collapsedRecipe.length }}
                          other items</span>
                      </div>
                      <ul class="w-full mt-2" v-if="checkCollapse('wed_collapse_'+index)">
                        <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                          v-show="checkRecipeExist( mc_option_recipe, getRecipeArray(element.recipes, mc_final_options_wed).collapsedRecipe)"
                          class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                          :title="$helpers.getByName(mc_option_recipe.total_val)">
                          <div class="flex gap-2 w-full justify-between group"
                            mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                            mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                            <div class="text-sm font-bold text-color-first-li">
                              <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                                {{ mc_option_recipe.name }}
                              </a>
                            </div>
                            <div>
                              <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                                <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                                  $helpers.getByFirstName(mc_option_recipe.total_val)
                                  }}</span>
                              </div>
                              <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                  class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                  fill="currentColor" @click="is_show = !is_show"
                                  if="hoveredIndex === mc_option_recipe.id + element.id">
                                  <path
                                    d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                </svg>

                                <div v-if="is_show"
                                  class="bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10">
                                  <RecipeMenuOption
                                    @replaceOptionRecipe="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'wed')"
                                    @attachRecipeToDefaultTag="attachRecipeToDefaultTag(mc_final_options_wed, mc_option_recipe)"
                                    @detachRecipeToDefaultTag="detachRecipeToDefaultTag( mc_final_options_wed,mc_option_recipe)"
                                    @deleteOptionRecipeButton="deleteOptionRecipeButton(mc_option_recipe,element, 'wed', index, 3)"
                                    @detachRecipeToTag="detachRecipeToTag" @attachRecipeToTag="attachRecipeToTag"
                                    :mc_option_recipe="mc_option_recipe" :default_tag="default_tag"
                                    :element="element" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div class="hidden group-hover/main:block text-bold">
                      <AddRecipe :element="element" :index="index" :day="'wed'" @makeAddRecipe="makeAddRecipe" />
                    </div>
                  </div>
                </div>
              </template>
            </draggable>

            <ListTag :mc_final_options="mc_final_options_wed" @sendRecipe="sendRecipe" :default_tag="default_tag" :shared_letters="shared_letters" :day_tag="day_tags['wed']" />

          </div>

          <!-----------------fourth------>
          <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">
            <header
              class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">

              <div class="left_coll flex gap-2 items-center">
                <h2 class="text-white text-lg font-bold cursor-pointer w-full"
                  :title="$helpers.getByName(mc_daily_sum_prod_thu)">Thursday</h2>

                <div style="z-index: 1;" class="h-[20px]">
                  <i v-show="showWarningHover(mc_daily_sum_prod_thu, mc_final_options_thu).length > 0 && getAllDay.includes('thu')"
                    v-on:mouseover="showThuAdditional = true"
                    v-on:mouseleave="showThuAdditional = false"
                    class="fa fa-exclamation-circle bg-white rounded-full text-[#cb0000] mr-auto text-lg "
                    style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
                  <ul v-show="showThuAdditional" class="absolute bg-white p-4 ml-4"
                    style="border-radius: 0px 10px 10px 10px;">
                    <li class="block text-black text-sm list-disc pb-1"
                      v-for="additional in showWarningHover(mc_daily_sum_prod_thu, mc_final_options_thu)">
                      {{ additional }}
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="total_planned_number_thu > 0 && mc_final_options_thu.length > 0" class="w-14">
                <input type="number"
                  class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
                  v-model="total_planned_number_thu" :disabled="true">
              </div>

              <div class="right_coll">
                <a href="#" @click="addRecipeOptionMenuCycle(4)">
                  <i class="fa fa-plus text-white pt-2 pr-2" aria-hidden="true"></i>
                </a>
              </div>
            </header>

            <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_thu" />

            <div v-if="!mc_final_options_thu.length"
              class="w-full flex flex-wrap items-center justify-center py-4">
              <div>
                <div class="text-center pl-8">
                  <img
                    :src="$page.props.asset_url + '/vendor/nutristudents/image/food-img/_Path_.png'">
                </div>
                <p class="pt-4 pl-2">Nothing Here Yet</p>
                <a href="#" @click="addRecipeOptionMenuCycle(4)" class="underline text-center block">Add
                  A
                  Menu Option</a>
                <button v-if="copied_option_data" type="button"
                  @click="addOptionPasteScript(mc_final_options_thu.length, 4)"
                  class="underline text-center block">Paste
                  Menu Option</button>
              </div>
            </div>

            <draggable class="list-group" :list="mc_final_options_thu" group="menus"
              @change="event => handleDrag(event, 4)">
              <template #item="{ element, index }">
                <div class="px-4 py-4 group/main">
                  <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item">
                    <ul>
                      <li class="flex flex-wrap justify-between pb-4 relative uppercase">
                        <div class="w-full flex flex-nowrap">
                          <div class=" flex w-full">
                            <div :title="$helpers.getByName(element.new_total_val)"
                              class="cursor-pointer max-w-[60%] w-full">{{ element.name }}
                            </div>

                            <span class="cursor-pointer pr-1 is_hide_production" @click="openTagPopup(element, index, 'thu')">
                              <img :src="$page.props.asset_url + '/images/download.svg'" class="w-6">
                            </span>
                          </div>
                          <input @change="changePlannedNumberValue(element, 'thu')" type="number"
                            v-model="element.planned_number"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden">

                          <div>
                            <MenuOption 
                              @messageFromChildEdit="addOptionEditScript(element, index, 4)"
                              @messageFromChildCopy="addOptionCopyScript(element)"
                              @messageFromChildPaste="addOptionPasteScript(mc_final_options_thu.length, 4)"
                              @messageFromChildDuplicate="addOptionDuplicateScript(element, mc_final_options_thu.length, 4)"
                              @messageFromChildDelete="addOptionDeleteScript(index, 4)"
                              @sendToAllReceives="sendToAllReceives(element)" />
                          </div>
                        </div>
                        <ListOptionTag :element="element" :default_tag="default_tag" @removeTag="removeTag" :shared_letters="shared_letters" :day_tag="day_tags['thu']" />
                      </li>

                      <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                        v-show="checkRecipeExist( mc_option_recipe, getRecipeArray(element.recipes, mc_final_options_thu).allRecipe)"
                        class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                        :title="$helpers.getByName(mc_option_recipe.total_val)">

                        <div class="flex gap-2 w-full justify-between group"
                          mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                          mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                          <div class="text-sm font-bold text-color-first-li">
                            <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                              {{ mc_option_recipe.name }}
                            </a>
                          </div>
                          <div>
                            <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                              <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                                $helpers.getByFirstName(mc_option_recipe.total_val)
                                }}</span>
                            </div>
                            <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                              <svg xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                fill="currentColor" @click="is_show = !is_show"
                                if="hoveredIndex === mc_option_recipe.id + element.id">
                                <path
                                  d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                              </svg>

                              <div v-if="is_show" class="
                                                            bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10 
                                                            ">
                                <RecipeMenuOption
                                  @replaceOptionRecipe="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'thu')"
                                  @attachRecipeToDefaultTag="attachRecipeToDefaultTag(mc_final_options_thu, mc_option_recipe)"
                                  @detachRecipeToDefaultTag="detachRecipeToDefaultTag( mc_final_options_thu,mc_option_recipe)"
                                  @deleteOptionRecipeButton="deleteOptionRecipeButton(mc_option_recipe,element, 'thu', index, 4)"
                                  @detachRecipeToTag="detachRecipeToTag" @attachRecipeToTag="attachRecipeToTag"
                                  :mc_option_recipe="mc_option_recipe" :default_tag="default_tag" :element="element" />

                              </div>
                            </div>
                          </div>
                        </div>

                      </li>
                    </ul>

                    <div v-if="getRecipeArray(element.recipes, mc_final_options_thu).collapsedRecipe.length > 0">
                      <div class="text-sm flex gap-1 items-center cursor-pointer"
                        @click="toggleCollapse('thu_collapse_'+index)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                          class="size-6 -ml-1 " :class="{ 'rotate-90': checkCollapse('thu_collapse_'+index)}">
                          <path fill-rule="evenodd"
                            d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                            clip-rule="evenodd" />
                        </svg>
                        <span>And {{ getRecipeArray(element.recipes, mc_final_options_thu).collapsedRecipe.length }}
                          other items</span>
                      </div>
                      <ul class="w-full mt-2" v-if="checkCollapse('thu_collapse_'+index)">
                        <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                          v-show="checkRecipeExist( mc_option_recipe, getRecipeArray(element.recipes, mc_final_options_thu).collapsedRecipe)"
                          class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                          :title="$helpers.getByName(mc_option_recipe.total_val)">
                          <div class="flex gap-2 w-full justify-between group"
                            mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                            mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                            <div class="text-sm font-bold text-color-first-li">
                              <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                                {{ mc_option_recipe.name }}
                              </a>
                            </div>
                            <div>
                              <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                                <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                                  $helpers.getByFirstName(mc_option_recipe.total_val)
                                  }}</span>
                              </div>
                              <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                  class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                  fill="currentColor" @click="is_show = !is_show"
                                  if="hoveredIndex === mc_option_recipe.id + element.id">
                                  <path
                                    d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                </svg>

                                <div v-if="is_show"
                                  class="bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10">
                                  <RecipeMenuOption
                                    @replaceOptionRecipe="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'thu')"
                                    @attachRecipeToDefaultTag="attachRecipeToDefaultTag(mc_final_options_thu, mc_option_recipe)"
                                    @detachRecipeToDefaultTag="detachRecipeToDefaultTag( mc_final_options_thu,mc_option_recipe)"
                                    @deleteOptionRecipeButton="deleteOptionRecipeButton(mc_option_recipe,element, 'thu', index, 4)"
                                    @detachRecipeToTag="detachRecipeToTag" @attachRecipeToTag="attachRecipeToTag"
                                    :mc_option_recipe="mc_option_recipe" :default_tag="default_tag"
                                    :element="element" />

                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div class="hidden group-hover/main:block text-bold">
                      <AddRecipe :element="element" :index="index" :day="'thu'" @makeAddRecipe="makeAddRecipe" />
                    </div>

                  </div>
                </div>
              </template>
            </draggable>

            <ListTag :mc_final_options="mc_final_options_thu" @sendRecipe="sendRecipe" :default_tag="default_tag" :shared_letters="shared_letters" :day_tag="day_tags['thu']" />

          </div>
          <!--------fivth----->
          <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">

            <header
              class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">
              <div class="left_coll flex gap-2 items-center">
                <h2 class="text-white text-lg font-bold cursor-pointer  w-full"
                  :title="$helpers.getByName(mc_daily_sum_prod_fri)">Friday</h2>

                <div class="h-[20px]" style="z-index: 1;">
                  <i v-show="showWarningHover(mc_daily_sum_prod_fri, mc_final_options_fri).length > 0 && getAllDay.includes('fri')"
                    v-on:mouseover="showFriAdditional = true"
                    v-on:mouseleave="showFriAdditional = false"
                    class="fa fa-exclamation-circle bg-white rounded-full text-[#cb0000] mr-auto text-lg "
                    style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
                  <ul v-show="showFriAdditional" class="absolute bg-white p-4 ml-4"
                    style="border-radius: 0px 10px 10px 10px;">
                    <li class="block text-black text-sm list-disc pb-1"
                      v-for="additional in showWarningHover(mc_daily_sum_prod_fri, mc_final_options_fri)">
                      {{ additional }}
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="total_planned_number_fri > 0 && mc_final_options_fri.length > 0" class="w-14">
                <input type="number"
                  class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
                  v-model="total_planned_number_fri" :disabled="true">
              </div>
              <div class="right_coll">
                <a href="#" @click="addRecipeOptionMenuCycle(5)">
                  <i class="fa fa-plus text-white pt-2 pr-2" aria-hidden="true"></i>
                </a>
              </div>
            </header>

            <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_fri" />

            <div v-if="!mc_final_options_fri.length"
              class="w-full flex flex-wrap items-center justify-center py-4">
              <div>
                <div class="text-center pl-8">
                  <img
                    :src="$page.props.asset_url + '/vendor/nutristudents/image/food-img/_Path_.png'">
                </div>
                <p class="pt-4 pl-2">Nothing Here Yet</p>
                <a href="#" @click="addRecipeOptionMenuCycle(5)" class="underline text-center block">Add
                  A
                  Menu Option</a>
                <button v-if="copied_option_data" type="button"
                  @click="addOptionPasteScript(mc_final_options_fri.length, 5)"
                  class="underline text-center block">Paste
                  Menu Option</button>
              </div>
            </div>

            <draggable class="list-group" :list="mc_final_options_fri" group="menus"
              @change="event => handleDrag(event, 5)">
              <template #item="{ element, index }">
                <div class="px-4 py-4 group/main">
                  <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item">
                    <ul>
                      <li class="flex flex-wrap justify-between pb-4 relative uppercase">
                        <div class="w-full flex flex-nowrap">
                          <div class="group flex w-full">
                            <div :title="$helpers.getByName(element.new_total_val)"
                              class="cursor-pointer max-w-[60%] w-full">{{ element.name }}
                            </div>

                            <span class="cursor-pointer pr-1 is_hide_production" @click="openTagPopup(element, index, 'fri')">
                              <img :src="$page.props.asset_url + '/images/download.svg'" class="w-6">
                            </span>
                          </div>
                          <input @change="changePlannedNumberValue(element, 'fri')" type="number"
                            v-model="element.planned_number"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden">

                          <div>
                            <MenuOption 
                              @messageFromChildEdit="addOptionEditScript(element, index, 5)"
                              @messageFromChildCopy="addOptionCopyScript(element)"
                              @messageFromChildPaste="addOptionPasteScript(mc_final_options_fri.length, 5)"
                              @messageFromChildDuplicate="addOptionDuplicateScript(element, mc_final_options_fri.length, 5)"
                              @messageFromChildDelete="addOptionDeleteScript(index, 5)"
                              @sendToAllReceives="sendToAllReceives(element)" />
                          </div>
                        </div>
                        <ListOptionTag :element="element" :default_tag="default_tag" @removeTag="removeTag" :shared_letters="shared_letters" :day_tag="day_tags['fri']" />
                      </li>
                      <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                        v-show="checkRecipeExist( mc_option_recipe, getRecipeArray(element.recipes, mc_final_options_fri).allRecipe)"
                        class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                        :title="$helpers.getByName(mc_option_recipe.total_val)">
                        <div class="flex gap-2 w-full justify-between group"
                          mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                          mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                          <div class="text-sm font-bold text-color-first-li">
                            <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                              {{ mc_option_recipe.name }}
                            </a>
                          </div>
                          <div>
                            <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                              <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                                $helpers.getByFirstName(mc_option_recipe.total_val)
                                }}</span>
                            </div>
                            <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                              <svg xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                fill="currentColor" @click="is_show = !is_show"
                                if="hoveredIndex === mc_option_recipe.id + element.id">
                                <path
                                  d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                              </svg>

                              <div v-if="is_show" class="
                                                            bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10 
                                                            ">

                                <RecipeMenuOption
                                  @replaceOptionRecipe="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'fri')"
                                  @attachRecipeToDefaultTag="attachRecipeToDefaultTag(mc_final_options_fri, mc_option_recipe)"
                                  @detachRecipeToDefaultTag="detachRecipeToDefaultTag( mc_final_options_fri,mc_option_recipe)"
                                  @deleteOptionRecipeButton="deleteOptionRecipeButton(mc_option_recipe,element, 'fri', index, 5)"
                                  @detachRecipeToTag="detachRecipeToTag" @attachRecipeToTag="attachRecipeToTag"
                                  :mc_option_recipe="mc_option_recipe" :default_tag="default_tag" :element="element" />


                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>

                    <div v-if="getRecipeArray(element.recipes, mc_final_options_fri).collapsedRecipe.length > 0">
                      <div class="text-sm flex gap-1 items-center cursor-pointer"
                        @click="toggleCollapse('fri_collapse_'+index)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                          class="size-6 -ml-1 " :class="{ 'rotate-90': checkCollapse('fri_collapse_'+index)}">
                          <path fill-rule="evenodd"
                            d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                            clip-rule="evenodd" />
                        </svg>
                        <span>And {{ getRecipeArray(element.recipes, mc_final_options_fri).collapsedRecipe.length }}
                          other items</span>
                      </div>
                      <ul class="w-full mt-2" v-if="checkCollapse('fri_collapse_'+index)">
                        <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                          v-show="checkRecipeExist( mc_option_recipe, getRecipeArray(element.recipes, mc_final_options_fri).collapsedRecipe)"
                          class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                          :title="$helpers.getByName(mc_option_recipe.total_val)">
                          <div class="flex gap-2 w-full justify-between group"
                            mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                            mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                            <div class="text-sm font-bold text-color-first-li">
                              <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                                {{ mc_option_recipe.name }}
                              </a>
                            </div>
                            <div>
                              <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                                <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                                  $helpers.getByFirstName(mc_option_recipe.total_val)
                                  }}</span>
                              </div>
                              <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                  class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                  fill="currentColor" @click="is_show = !is_show"
                                  if="hoveredIndex === mc_option_recipe.id + element.id">
                                  <path
                                    d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                </svg>

                                <div v-if="is_show"
                                  class="bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10">
                                  <RecipeMenuOption
                                    @replaceOptionRecipe="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'fri')"
                                    @attachRecipeToDefaultTag="attachRecipeToDefaultTag(mc_final_options_fri, mc_option_recipe)"
                                    @detachRecipeToDefaultTag="detachRecipeToDefaultTag( mc_final_options_fri,mc_option_recipe)"
                                    @deleteOptionRecipeButton="deleteOptionRecipeButton(mc_option_recipe,element, 'fri', index, 5)"
                                    @detachRecipeToTag="detachRecipeToTag" @attachRecipeToTag="attachRecipeToTag"
                                    :mc_option_recipe="mc_option_recipe" :default_tag="default_tag"
                                    :element="element" />


                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div class="hidden group-hover/main:block text-bold">
                      <AddRecipe :element="element" :index="index" :day="'fri'" @makeAddRecipe="makeAddRecipe" />
                    </div>
                  </div>
                </div>
              </template>
            </draggable>
            <ListTag :mc_final_options="mc_final_options_fri" @sendRecipe="sendRecipe" :default_tag="default_tag" :shared_letters="shared_letters" :day_tag="day_tags['fri']" />

          </div>
          <!------------------six----------->
          <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">
            <header
              class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">
              <div class="left_coll flex gap-2 items-center">
                <h2 class="text-white text-lg font-bold  cursor-pointer w-full"
                  :title="$helpers.getByName(mc_daily_sum_prod_sat)">Saturday</h2>
                <div class="h-[20px]" style="z-index: 1;">
                  <i v-show="showWarningHover(mc_daily_sum_prod_sat, mc_final_options_sat).length > 0 && getAllDay.includes('sat')"
                    v-on:mouseover="showSatAdditional = true"
                    v-on:mouseleave="showSatAdditional = false"
                    class="fa fa-exclamation-circle bg-white rounded-full text-[#cb0000] mr-auto text-lg "
                    style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
                  <ul v-show="showSatAdditional" class="absolute bg-white p-4 ml-4"
                    style="border-radius: 0px 10px 10px 10px;">
                    <li v-for="additional in showWarningHover(mc_daily_sum_prod_sat, mc_final_options_sat)"
                      class="block text-black text-sm list-disc pb-1">
                      {{ additional }}
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="total_planned_number_sat > 0 && mc_final_options_sat.length > 0" class="w-14">
                <input type="number"
                  class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
                  v-model="total_planned_number_sat" :disabled="true">
              </div>
              <div class="right_coll">
                <a href="#" @click="addRecipeOptionMenuCycle(6)">
                  <i class="fa fa-plus text-white pt-2 pr-2" aria-hidden="true"></i>
                </a>
              </div>
            </header>

            <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_sat" />

            <div v-if="!mc_final_options_sat.length"
              class="w-full flex flex-wrap items-center justify-center py-4">
              <div>
                <div class="text-center pl-8">
                  <img
                    :src="$page.props.asset_url + '/vendor/nutristudents/image/food-img/_Path_.png'">
                </div>
                <p class="pt-4 pl-2">Nothing Here Yet</p>
                <a href="#" @click="addRecipeOptionMenuCycle(6)" class="underline text-center block">Add
                  A
                  Menu Option</a>
                <button v-if="copied_option_data" type="button"
                  @click="addOptionPasteScript(mc_final_options_sat.length, 6)"
                  class="underline text-center block">Paste
                  Menu Option</button>
              </div>
            </div>

            <draggable class="list-group" :list="mc_final_options_sat" group="menus"
              @change="event => handleDrag(event, 6)">
              <template #item="{ element, index }">
                <div class="px-4 py-4 group/main">
                  <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item">
                    <ul>
                      <li class="flex flex-wrap justify-between pb-4 relative uppercase">
                        <div class="w-full flex flex-nowrap">
                          <div class="group flex w-full">
                            <div :title="$helpers.getByName(element.new_total_val)"
                              class="cursor-pointer max-w-[60%] w-full">{{ element.name }}
                            </div>

                            <span class="cursor-pointer pr-1 is_hide_production" @click="openTagPopup(element, index, 'sat')">
                              <img :src="$page.props.asset_url + '/images/download.svg'" class="w-6">
                            </span>
                          </div>
                          <input @change="changePlannedNumberValue(element, 'sat')" type="number"
                            v-model="element.planned_number"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden">

                          <div>
                            <MenuOption 
                              @messageFromChildEdit="addOptionEditScript(element, index, 6)"
                              @messageFromChildCopy="addOptionCopyScript(element)"
                              @messageFromChildPaste="addOptionPasteScript(mc_final_options_sat.length, 6)"
                              @messageFromChildDuplicate="addOptionDuplicateScript(element, mc_final_options_sat.length, 6)"
                              @messageFromChildDelete="addOptionDeleteScript(index, 6)"
                              @sendToAllReceives="sendToAllReceives(element)" />
                          </div>
                        </div>
                        <ListOptionTag :element="element" :default_tag="default_tag" @removeTag="removeTag" :shared_letters="shared_letters" :day_tag="day_tags['sat']" />
                      </li>
                      <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                        v-show="checkRecipeExist( mc_option_recipe, getRecipeArray(element.recipes, mc_final_options_sat).allRecipe)"
                        class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                        :title="$helpers.getByName(mc_option_recipe.total_val)">

                        <div class="flex gap-2 w-full justify-between group"
                          mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                          mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                          <div class="text-sm font-bold text-color-first-li">
                            <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                              {{ mc_option_recipe.name }}
                            </a>
                          </div>
                          <div>
                            <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                              <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                                $helpers.getByFirstName(mc_option_recipe.total_val)
                                }}</span>
                            </div>
                            <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                              <svg xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                fill="currentColor" @click="is_show = !is_show"
                                if="hoveredIndex === mc_option_recipe.id + element.id">
                                <path
                                  d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                              </svg>

                              <div v-if="is_show" class="
                                                            bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10 
                                                            ">

                                <RecipeMenuOption
                                  @replaceOptionRecipe="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'sat')"
                                  @attachRecipeToDefaultTag="attachRecipeToDefaultTag(mc_final_options_sat, mc_option_recipe)"
                                  @detachRecipeToDefaultTag="detachRecipeToDefaultTag( mc_final_options_sat,mc_option_recipe)"
                                  @deleteOptionRecipeButton="deleteOptionRecipeButton(mc_option_recipe,element, 'sat', index, 6)"
                                  @detachRecipeToTag="detachRecipeToTag" @attachRecipeToTag="attachRecipeToTag"
                                  :mc_option_recipe="mc_option_recipe" :default_tag="default_tag" :element="element" />


                              </div>
                            </div>
                          </div>
                        </div>

                      </li>
                    </ul>

                    <div v-if="getRecipeArray(element.recipes, mc_final_options_sat).collapsedRecipe.length > 0">
                      <div class="text-sm flex gap-1 items-center cursor-pointer"
                        @click="toggleCollapse('sat_collapse_'+index)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                          class="size-6 -ml-1 " :class="{ 'rotate-90': checkCollapse('sat_collapse_'+index)}">
                          <path fill-rule="evenodd"
                            d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                            clip-rule="evenodd" />
                        </svg>
                        <span>And {{ getRecipeArray(element.recipes, mc_final_options_sat).collapsedRecipe.length }}
                          other items</span>
                      </div>
                      <ul class="w-full mt-2" v-if="checkCollapse('sat_collapse_'+index)">
                        <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                          v-show="checkRecipeExist( mc_option_recipe, getRecipeArray(element.recipes, mc_final_options_sat).collapsedRecipe)"
                          class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                          :title="$helpers.getByName(mc_option_recipe.total_val)">
                          <div class="flex gap-2 w-full justify-between group"
                            mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                            mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                            <div class="text-sm font-bold text-color-first-li">
                              <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                                {{ mc_option_recipe.name }}
                              </a>
                            </div>
                            <div>
                              <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                                <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                                  $helpers.getByFirstName(mc_option_recipe.total_val)
                                  }}</span>
                              </div>
                              <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                  class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                  fill="currentColor" @click="is_show = !is_show"
                                  if="hoveredIndex === mc_option_recipe.id + element.id">
                                  <path
                                    d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                </svg>

                                <div v-if="is_show"
                                  class="bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10">
                                  <RecipeMenuOption
                                    @replaceOptionRecipe="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'sat')"
                                    @attachRecipeToDefaultTag="attachRecipeToDefaultTag(mc_final_options_sat, mc_option_recipe)"
                                    @detachRecipeToDefaultTag="detachRecipeToDefaultTag( mc_final_options_sat,mc_option_recipe)"
                                    @deleteOptionRecipeButton="deleteOptionRecipeButton(mc_option_recipe,element, 'sat', index, 6)"
                                    @detachRecipeToTag="detachRecipeToTag" @attachRecipeToTag="attachRecipeToTag"
                                    :mc_option_recipe="mc_option_recipe" :default_tag="default_tag"
                                    :element="element" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div class="hidden group-hover/main:block text-bold">
                      <AddRecipe :element="element" :index="index" :day="'sat'" @makeAddRecipe="makeAddRecipe" />
                    </div>
                  </div>
                </div>
              </template>
            </draggable>
            <ListTag :mc_final_options="mc_final_options_sat" @sendRecipe="sendRecipe" :default_tag="default_tag" :shared_letters="shared_letters" :day_tag="day_tags['sat']" />


          </div>
          <!--------seven------->
          <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">

            <header
              class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">
              <div class="left_coll flex gap-2 items-center">
                <h2 class="text-white text-lg font-bold cursor-pointer w-full"
                  :title="$helpers.getByName(mc_daily_sum_prod_sun)">Sunday</h2>
                <div style="z-index: 1;" class="h-[20px]">
                  <i v-show="showWarningHover(mc_daily_sum_prod_sun, mc_final_options_sun).length > 0 && getAllDay.includes('sun')"
                    class="fa fa-exclamation-circle bg-white rounded-full text-[#cb0000] mr-auto text-lg "
                    v-on:mouseover="showSunAdditional = true"
                    v-on:mouseleave="showSunAdditional = false"
                    style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
                  <ul v-show="showSunAdditional" class="absolute bg-white p-4 ml-4"
                    style="border-radius: 0px 10px 10px 10px;">
                    <li v-for="additional in showWarningHover(mc_daily_sum_prod_sun, mc_final_options_sun)"
                      class="block text-black text-sm list-disc pb-1">
                      {{ additional }}
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="total_planned_number_sun > 0 && mc_final_options_sun.length > 0" class="w-14">
                <input type="number"
                  class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
                  v-model="total_planned_number_sun" :disabled="true">
              </div>
              <div class="right_coll">
                <a href="#" @click="addRecipeOptionMenuCycle(7)">
                  <i class="fa fa-plus text-white pt-2 pr-2" aria-hidden="true"></i>
                </a>
              </div>
            </header>

            <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_sun" />

            <div v-if="!mc_final_options_sun.length"
              class="w-full flex flex-wrap items-center justify-center py-4">
              <div>
                <div class="text-center pl-8">
                  <img
                    :src="$page.props.asset_url + '/vendor/nutristudents/image/food-img/_Path_.png'">
                </div>
                <p class="pt-4 pl-2">Nothing Here Yet</p>
                <a href="#" @click="addRecipeOptionMenuCycle(7)" class="underline text-center block">Add
                  A
                  Menu Option</a>
                <button v-if="copied_option_data" type="button"
                  @click="addOptionPasteScript(mc_final_options_sun.length, 7)"
                  class="underline text-center block">Paste
                  Menu Option</button>
              </div>
            </div>

            <draggable class="list-group" :list="mc_final_options_sun" group="menus"
              @change="event => handleDrag(event, 7)">
              <template #item="{ element, index }">
                <div class="px-4 py-4 group/main">
                  <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item">
                    <ul>
                      <li class="flex flex-wrap justify-between pb-4 relative uppercase">
                        <div class="w-full flex flex-nowrap">
                          <div class=" flex w-full">
                            <div :title="$helpers.getByName(element.new_total_val)"
                              class="cursor-pointer max-w-[60%] w-full">{{ element.name }}
                            </div>

                            <span class="cursor-pointer pr-1 is_hide_production" @click="openTagPopup(element, index, 'sun')">
                              <img :src="$page.props.asset_url + '/images/download.svg'" class="w-6">
                            </span>
                          </div>
                          <input @change="changePlannedNumberValue(element, 'sun')" type="number"
                            v-model="element.planned_number"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden">
                          <div>
                            <MenuOption 
                              @messageFromChildEdit="addOptionEditScript(element, index, 7)"
                              @messageFromChildCopy="addOptionCopyScript(element)"
                              @messageFromChildPaste="addOptionPasteScript(mc_final_options_sun.length, 7)"
                              @messageFromChildDuplicate="addOptionDuplicateScript(element, mc_final_options_sun.length, 7)"
                              @messageFromChildDelete="addOptionDeleteScript(index, 7)"
                              @sendToAllReceives="sendToAllReceives(element)" />
                          </div>
                        </div>
                        <ListOptionTag :element="element" :default_tag="default_tag" @removeTag="removeTag" :shared_letters="shared_letters" :day_tag="day_tags['sun']" />
                      </li>

                      <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                        v-show="checkRecipeExist( mc_option_recipe, getRecipeArray(element.recipes, mc_final_options_sun).allRecipe)"
                        class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                        :title="$helpers.getByName(mc_option_recipe.total_val)">

                        <div class="flex gap-2 w-full justify-between group"
                          mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                          mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                          <div class="text-sm font-bold text-color-first-li">
                            <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                              {{ mc_option_recipe.name }}
                            </a>
                          </div>
                          <div>
                            <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                              <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                                $helpers.getByFirstName(mc_option_recipe.total_val)
                                }}</span>
                            </div>
                            <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                              <svg xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                fill="currentColor" @click="is_show = !is_show"
                                if="hoveredIndex === mc_option_recipe.id + element.id">
                                <path
                                  d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                              </svg>

                              <div v-if="is_show" class="
                                                            bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10 
                                                            ">

                                <RecipeMenuOption
                                  @replaceOptionRecipe="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'sun')"
                                  @attachRecipeToDefaultTag="attachRecipeToDefaultTag(mc_final_options_sun, mc_option_recipe)"
                                  @detachRecipeToDefaultTag="detachRecipeToDefaultTag( mc_final_options_sun,mc_option_recipe)"
                                  @deleteOptionRecipeButton="deleteOptionRecipeButton(mc_option_recipe,element, 'sun', index, 7)"
                                  @detachRecipeToTag="detachRecipeToTag" @attachRecipeToTag="attachRecipeToTag"
                                  :mc_option_recipe="mc_option_recipe" :default_tag="default_tag" :element="element" />

                              </div>
                            </div>
                          </div>
                        </div>

                      </li>
                    </ul>

                    <div v-if="getRecipeArray(element.recipes, mc_final_options_sun).collapsedRecipe.length > 0">
                      <div class="text-sm flex gap-1 items-center cursor-pointer"
                        @click="toggleCollapse('sun_collapse_'+index)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                          class="size-6 -ml-1 " :class="{ 'rotate-90': checkCollapse('sun_collapse_'+index)}">
                          <path fill-rule="evenodd"
                            d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                            clip-rule="evenodd" />
                        </svg>
                        <span>And {{ getRecipeArray(element.recipes, mc_final_options_sun).collapsedRecipe.length }}
                          other items</span>
                      </div>
                      <ul class="w-full mt-2" v-if="checkCollapse('sun_collapse_'+index)">
                        <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                          v-show="checkRecipeExist( mc_option_recipe, getRecipeArray(element.recipes, mc_final_options_sun).collapsedRecipe)"
                          class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                          :title="$helpers.getByName(mc_option_recipe.total_val)">
                          <div class="flex gap-2 w-full justify-between group"
                            mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                            mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                            <div class="text-sm font-bold text-color-first-li">
                              <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                                {{ mc_option_recipe.name }}
                              </a>
                            </div>
                            <div>
                              <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                                <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                                  $helpers.getByFirstName(mc_option_recipe.total_val)
                                  }}</span>
                              </div>
                              <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                  class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                  fill="currentColor" @click="is_show = !is_show"
                                  if="hoveredIndex === mc_option_recipe.id + element.id">
                                  <path
                                    d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                </svg>

                                <div v-if="is_show"
                                  class="bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10">
                                  <RecipeMenuOption
                                    @replaceOptionRecipe="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'sun')"
                                    @attachRecipeToDefaultTag="attachRecipeToDefaultTag(mc_final_options_sun, mc_option_recipe)"
                                    @detachRecipeToDefaultTag="detachRecipeToDefaultTag( mc_final_options_sun,mc_option_recipe)"
                                    @deleteOptionRecipeButton="deleteOptionRecipeButton(mc_option_recipe,element, 'sun', index, 7)"
                                    @detachRecipeToTag="detachRecipeToTag" @attachRecipeToTag="attachRecipeToTag"
                                    :mc_option_recipe="mc_option_recipe" :default_tag="default_tag"
                                    :element="element" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div class="hidden group-hover/main:block text-bold">
                      <AddRecipe :element="element" :index="index" :day="'sun'" @makeAddRecipe="makeAddRecipe" />
                    </div>
                  </div>
                </div>
              </template>
            </draggable>
            <ListTag :mc_final_options="mc_final_options_sun" @sendRecipe="sendRecipe" :default_tag="default_tag" :shared_letters="shared_letters" :day_tag="day_tags['sun']" />

          </div>

        </div>
      </div>
    </form>

    <WeekCycleDayHover v-if="addRecipesOptionModal" :addRecipesOptionModal="addRecipesOptionModal"
      :dayNumber="day_number" :optionNumber="option_number" :editOptionData="editOptionData"
      :categories="categories" @closeModal="closeOptionsModal" @closeEditModal="closeEditOptionsModal"
      :name="name" :is_fav_show="is_fav_show" :mass_measurements="mass_measurements"
      :volume_measurements="volume_measurements" :unit_measurements="unit_measurements" />


    <OptionReplacePopUp v-if="optionReplacePopup" :optionReplacePopup="optionReplacePopup" :recipe="selectedRecipe"
      :optionReplaceArray="optionReplaceArray" :getAllRecipes="getAllRecipes" :weeklyAvg="weeklyAvg"
      :mc_weekly_avg_prods="mc_weekly_avg_prods" :guideline_data="guideline_data"
      @closeOptionPopup="closeOptionReplacePopup" @makeReplaceRecipe="makeReplaceRecipe" :datas="datas"
      :getAllDay="getAllDay" :menucycle="menucycle" :days_data="days_data" :form="form"
      :mc_daily_sum_prod_mon1="mc_daily_sum_prod_mon" :mc_final_options_mon1="mc_final_options_mon"
      :mc_daily_sum_prod_tue1="mc_daily_sum_prod_tue" :mc_final_options_tue1="mc_final_options_tue"
      :mc_daily_sum_prod_wed1="mc_daily_sum_prod_wed" :mc_final_options_wed1="mc_final_options_wed"
      :mc_daily_sum_prod_thu1="mc_daily_sum_prod_thu" :mc_final_options_thu1="mc_final_options_thu"
      :mc_daily_sum_prod_fri1="mc_daily_sum_prod_fri" :mc_final_options_fri1="mc_final_options_fri"
      :mc_daily_sum_prod_sat1="mc_daily_sum_prod_sat" :mc_final_options_sat1="mc_final_options_sat"
      :mc_daily_sum_prod_sun1="mc_daily_sum_prod_sun" :mc_final_options_sun1="mc_final_options_sun"
      :myname1="myname" :null_nutrient="null_nutrient" :override_components="override_components" />
    <AddTag v-if="isOpenTagModel" :isOpenTagModel="isOpenTagModel" @closeTagPopup="closeTagPopup" @attachTag="attachTag" :existTags="TagOptions['tags']" @handleTagSortable="handleTagSortable"  @removeDayTag="removeDayTag" :shared_letters="shared_letters" />


  </default-layout>

  <jet-dialog-modal :show="changeMonthYearModal" @close="changeMonthYearModal = false">

    <template #title>
      <div class="flex justify-between items-center">Menu Weeks</div>
    </template>
    <template #content>
      <div class="row">
        <div class="flex mt-6 ml-4 lg:w-4/5 md:w-3/5 w-full">
          <label>Name*</label>
          <div class="relative focus:outline-none md:w-3/5 w-full mr-3 xl:mt-0 md:ml-2 ml-0">
            <input type="text" placeholder="Week1" id="mc_name" name="mc_name" v-model="form.mc_name"
              class="w-full shadow-sm focus:border-none block sm:text-sm border-gray-300  rounded-lg w-full select-menu-height input-background">
            <div v-if="form.errors.mc_name" class="validation_error_msg">{{ form.errors.mc_name }}</div>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <button type="submit" @click="saveAsTemplate"
        class="md:w-24 w-full button-color text-white font-bold py-3 rounded md:mt-0 mt-4 px-4 md:ml-2 ml-0 text-xs mr-2">SAVE</button>
      <jet-secondary-button @click="changeMonthYearModal = false" class="py-3">Close</jet-secondary-button>
    </template>
  </jet-dialog-modal>
</template>

<script>
  import DefaultLayout from "@/Layouts/DefaultLayout";
  import PageTitleLayout from "@/Pages/Common/PageTitle";
  import TableIndexLayout from "@/Pages/Common/TableIndex";
  import MenuOption from "@/Pages/MenuCycle/MenuOption";
  import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
  import JetButton from '@/Jetstream/Button';
  import JetSecondaryButton from '@/Jetstream/SecondaryButton';
  import JetDialogModal from '@/Jetstream/DialogModal';
  import WeekCycleDayHover from "@/Pages/WeekCycles/WeekCycleDayHover";
  import WeeklyCalculatedTotals from "@/Pages/MenuCycle/WeeklyCalculatedTotals";
  import WeekDayTotals from "@/Pages/MenuCycle/WeekDayTotals";
  import draggable from "vuedraggable";
  import OptionReplacePopUp from "@/Pages/MenuCycle/OptionReplacePopUp";
  // import AddNewRecipe from "@/Pages/MenuCycle/AddNewRecipe";
  import AddRecipe from "@/Pages/MenuCycle/AddRecipe";
  import AddTag from "@/Pages/MenuCycle/Tag/AddTag";
  import ListTag from "@/Pages/MenuCycle/Tag/ListTag";
  import AddNewRecipe from "@/Pages/MenuCycle/AddNewRecipe";
  import ListOptionTag from "@/Pages/MenuCycle/Tag/ListOptionTag";
  import RecipeMenuOption from "@/Pages/MenuCycle/RecipeMenuOption";



  export default {
    props: ['selected_mealtype', 'selected_agerange', 'selected_days', 'mealtype_data', 'agerange_data', 'days_data', 'categories', 'month', 'year', 'weekNumber', 'site', 'guide_line_id', 'menuName', 'is_template', 'is_fav_show', "mass_measurements", "volume_measurements", "unit_measurements", "type", 'offering_id', 'shared_letters', 'dayTags'],
    components: {
      DefaultLayout,
      PageTitleLayout,
      TableIndexLayout,
      BreadcrumLayout,
      MenuOption,
      JetButton,
      JetSecondaryButton,
      JetDialogModal,
      WeekCycleDayHover,
      WeeklyCalculatedTotals,
      WeekDayTotals,
      draggable,
      OptionReplacePopUp,
      AddNewRecipe,
      AddRecipe,
      AddTag,
      ListTag,
      RecipeMenuOption,
      ListOptionTag
    },

    data() {
      return {
        null_nutrient: [],
        override_components: [],
        day_tags : this.dayTags,

        isOpenTagModel: false,
        TagOptions: [],
        collapseStates: new Map(),
        default_tag: null,


        dgragDropTrueFalse: false,
        showMonAdditional: false,
        showTueAdditional: false,
        showWebAdditional: false,
        showThuAdditional: false,
        showFriAdditional: false,
        showSatAdditional: false,
        showSunAdditional: false,

        addNewRecipeArray: null,
        newRecipePopup: false,


        datas: [{
            name: 'MMA',
            type: 'component',
            min: 'daily_min_usda_componenent_serving_meat',
            max: 'daily_max_usda_componenent_serving_meat'
          },
          {
            name: 'WGR',
            type: 'component',
            min: 'daily_min_usda_componenent_serving_grain',
            max: 'daily_max_usda_componenent_serving_grain'
          },
          {
            name: 'FRU',
            type: 'component',
            min: 'daily_min_usda_componenent_serving_fruit',
            max: 'daily_max_usda_componenent_serving_fruit'
          },
          {
            name: 'MLK',
            type: 'component',
            min: 'daily_min_usda_componenent_serving_milk',
            max: 'daily_max_usda_componenent_serving_milk'
          },
          {
            name: 'VEG',
            type: 'component',
            min: 'daily_min_usda_componenent_serving_veg',
            max: 'daily_max_usda_componenent_serving_veg'
          },
          {
            name: 'DG',
            type: 'component',
            min: 'daily_min_usda_componenent_serving_veggrn',
            max: 'daily_max_usda_componenent_serving_veggrn'
          },
          {
            name: 'RO',
            type: 'component',
            min: 'daily_min_usda_componenent_serving_vegred',
            max: 'daily_max_usda_componenent_serving_vegred'
          },
          {
            name: 'BPL',
            type: 'component',
            min: 'daily_min_usda_componenent_serving_vegleg',
            max: 'daily_max_usda_componenent_serving_vegleg'
          },

          {
            name: 'STAR',
            type: 'component',
            min: 'daily_min_usda_componenent_serving_vegstar',
            max: 'daily_max_usda_componenent_serving_vegstar'
          },
          {
            name: 'OTH',
            type: 'component',
            min: 'daily_min_usda_componenent_serving_vegothr',
            max: 'daily_max_usda_componenent_serving_vegothr'
          },
          {
            name: 'CALS',
            type: '',
            min: 'daily_min_nutrition_facts_calories',
            max: 'daily_max_nutrition_facts_calories'
          },
          {
            name: 'SOD',
            type: '',
            min: 'daily_min_nutrition_facts_sodium',
            max: 'daily_max_nutrition_facts_sodium'
          },
          {
            name: 'FAT',
            type: '',
            min: 'daily_min_nutrition_facts_totalfat',
            max: 'daily_max_nutrition_facts_totalfat'
          },
          {
            name: 'PROT',
            type: '',
            min: 'daily_min_nutrition_facts_protein',
            max: 'daily_max_nutrition_facts_protein'
          },
          {
            name: 'CARB',
            type: '',
            min: 'daily_min_nutrition_facts_carbs',
            max: 'daily_max_nutrition_facts_carbs'
          },

          {
            name: 'calfat',
            type: '',
            min: 'daily_min_nutrition_facts_calfat',
            max: 'daily_max_nutrition_facts_calfat',
            unit: ''
          },

          {
            name: 'satfat',
            type: '',
            min: 'daily_min_nutrition_facts_satfat',
            max: 'daily_max_nutrition_facts_satfat',
            unit: ''
          },

          {
            name: 'transfat',
            type: '',
            min: 'daily_min_nutrition_facts_transfat',
            max: 'daily_max_nutrition_facts_transfat',
            unit: ''
          },

          {
            name: 'polysatfat',
            type: '',
            min: 'daily_min_nutrition_facts_polysatfat',
            max: 'daily_max_nutrition_facts_polysatfat',
            unit: ''
          },
          {
            name: 'monosatfat',
            type: '',
            min: 'daily_min_nutrition_facts_monosatfat',
            max: 'daily_max_nutrition_facts_monosatfat',
            unit: ''
          },
          {
            name: 'cholesterol',
            type: '',
            min: 'daily_min_nutrition_facts_cholesterol',
            max: 'daily_max_nutrition_facts_cholesterol',
            unit: ''
          },
          {
            name: 'potassium',
            type: '',
            min: 'daily_min_nutrition_facts_potassium',
            max: 'daily_max_nutrition_facts_potassium',
            unit: 'mg'
          },
          {
            name: 'fiber',
            type: '',
            min: 'daily_min_nutrition_facts_fiber',
            max: 'daily_max_nutrition_facts_fiber',
            unit: 'g'
          },
          {
            name: 'sugar',
            type: '',
            min: 'daily_min_nutrition_facts_sugar',
            max: 'daily_max_nutrition_facts_sugar',
            unit: 'g'
          },
          {
            name: 'vitamina',
            type: '',
            min: 'daily_min_nutrition_facts_vitamina',
            max: 'daily_max_nutrition_facts_vitamina',
            unit: 'mcg RAE'
          },
          {
            name: 'vitaminb6',
            type: '',
            min: 'daily_min_nutrition_facts_vitaminb6',
            max: 'daily_max_nutrition_facts_vitaminb6',
            unit: 'mg'
          },
          {
            name: 'vitaminb12',
            type: '',
            min: 'daily_min_nutrition_facts_vitaminb12',
            max: 'daily_max_nutrition_facts_vitaminb12',
            unit: 'mcg '
          },
          {
            name: 'vitaminc',
            type: '',
            min: 'daily_min_nutrition_facts_vitaminc',
            max: 'daily_max_nutrition_facts_vitaminc',
            unit: 'mg'
          },
          {
            name: 'vitamind',
            type: '',
            min: 'daily_min_nutrition_facts_vitamind',
            max: 'daily_max_nutrition_facts_vitamind',
            unit: 'mcg'
          },
          {
            name: 'vitamine',
            type: '',
            min: 'daily_min_nutrition_facts_vitamine',
            max: 'daily_max_nutrition_facts_vitamine',
            unit: 'mg'
          },
          {
            name: 'calcium',
            type: '',
            min: 'daily_min_nutrition_facts_calcium',
            max: 'daily_max_nutrition_facts_calcium',
            unit: 'mg'
          },
          {
            name: 'iron',
            type: '',
            min: 'daily_min_nutrition_facts_iron',
            max: 'daily_max_nutrition_facts_iron',
            unit: 'mg'
          },
          {
            name: 'magnesium',
            type: '',
            min: 'daily_min_nutrition_facts_magnesium',
            max: 'daily_max_nutrition_facts_magnesium',
            unit: 'mg'
          },
          {
            name: 'coblamin',
            type: '',
            min: 'daily_min_nutrition_facts_coblamin',
            max: 'daily_max_nutrition_facts_coblamin',
            unit: 'mg'
          },
          {
            name: 'thiamin',
            type: '',
            min: 'daily_min_nutrition_facts_thiamin',
            max: 'daily_max_nutrition_facts_thiamin',
            unit: 'mg'
          },
          {
            name: 'riboflavin',
            type: '',
            min: 'daily_min_nutrition_facts_riboflavin',
            max: 'daily_max_nutrition_facts_riboflavin',
            unit: 'mg'
          },
          {
            name: 'niacin',
            type: '',
            min: 'daily_min_nutrition_facts_niacin',
            max: 'daily_max_nutrition_facts_niacin',
            unit: 'mg'
          },
          {
            name: 'zinc',
            type: '',
            min: 'daily_min_nutrition_facts_zinc',
            max: 'daily_max_nutrition_facts_zinc',
            unit: 'mg'
          },
          {
            name: 'water',
            type: '',
            min: 'daily_min_nutrition_facts_water',
            max: 'daily_max_nutrition_facts_water',
            unit: 'g'
          },
          {
            name: 'ash',
            type: '',
            min: 'daily_min_nutrition_facts_ash',
            max: 'daily_max_nutrition_facts_ash',
            unit: 'g'
          },
          {
            name: 'added_sugars',
            type: '',
            min: 'daily_min_nutrition_facts_added_sugars',
            max: 'daily_max_nutrition_facts_added_sugars',
            unit: 'g'
          }
        ],

        // meal_types : this.meal_types_data,
        // guideline_data:'',
        // offering_site:[],
        log: console.log,
        changeMonthYearModal: false,
        name: '',
        guidelines: [],
        guideline_data: [],

        //Option Replace Popup Variables
        hoveredIndex: null,
        is_show: '',
        selectedRecipe: null,
        optionReplacePopup: false,
        optionReplaceArray: null,
        // menucycle: {
        //     mc_id: null,
        //     mc_name: '',
        //     meal_type_id: '',
        //     age_grade_id: '',
        //     days_id: '',
        //     guideline_id: '',
        // },
        //End Option Replace Popup Variables



        mc_final_options_mon: [],
        mc_final_options_tue: [],
        mc_final_options_wed: [],
        mc_final_options_thu: [],
        mc_final_options_fri: [],
        mc_final_options_sat: [],
        mc_final_options_sun: [],

        mc_recipes_mon: [],
        mc_recipes_tue: [],
        mc_recipes_wed: [],
        mc_recipes_thu: [],
        mc_recipes_fri: [],
        mc_recipes_sat: [],
        mc_recipes_sun: [],

        mc_recipe_prefer_prod_mon: [],
        mc_recipe_prefer_prod_tue: [],
        mc_recipe_prefer_prod_wed: [],
        mc_recipe_prefer_prod_thu: [],
        mc_recipe_prefer_prod_fri: [],
        mc_recipe_prefer_prod_sat: [],
        mc_recipe_prefer_prod_sun: [],

        mc_daily_sum_prod_mon: [],
        mc_daily_sum_prod_tue: [],
        mc_daily_sum_prod_wed: [],
        mc_daily_sum_prod_thu: [],
        mc_daily_sum_prod_fri: [],
        mc_daily_sum_prod_sat: [],
        mc_daily_sum_prod_sun: [],

        mc_daily_sum_prod_mon_all_data: [],
        mc_daily_sum_prod_tue_all_data: [],
        mc_daily_sum_prod_wed_all_data: [],
        mc_daily_sum_prod_thu_all_data: [],
        mc_daily_sum_prod_fri_all_data: [],
        mc_daily_sum_prod_sat_all_data: [],
        mc_daily_sum_prod_sun_all_data: [],

        mc_weekly_avg_prods: [],

        day_number: 0,
        option_number: 0,
        editOptionData: [],
        plannedNumber: 1,


        addRecipesOptionModal: false,

        copied_option_data: '',
        copied_option_data_drag_drop: '',

        sum_products_daily: [],
        avg_products_weekly: [],
        avg_products_weekly_all_data: [
          [],
          [],
          [],
          [],
          [],
          [],
          []
        ],
        todal_days: 0,

        form: this.$inertia.form({
          day_tags : [],
          is_template: this.is_template,
          mc_name: '',
          mc_meal_type: '',
          mc_grade_range: '',
          week_number: '',

          meal_type_id: '',
          age_grade_id: '',
          days_id: '',
          guideline_id: this.guide_line_id,
          site: this.site,
          type: this.type,
          offering_id: this.offering_id,
          month: this.month,
          year: this.year,
          weekNumber: this.weekNumber,
          mealtype: '',
          agerange: '',
          days: '',

          mc_options_mon: [],
          mc_options_tue: [],
          mc_options_wed: [],
          mc_options_thu: [],
          mc_options_fri: [],
          mc_options_sat: [],
          mc_options_sun: [],
        }),

        total_planned_number_mon: 0,
        total_planned_number_tue: 0,
        total_planned_number_wed: 0,
        total_planned_number_thu: 0,
        total_planned_number_fri: 0,
        total_planned_number_sat: 0,
        total_planned_number_sun: 0,
      }
    },

    computed: {
      // a computed getter
      getAllDay() {
        let days = [];
        if (this.form.days_id) {
          const dayData = this.days_data.find(day => day.id === this.form.days_id);
          if (dayData) {
            const allDays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
            days = allDays.filter(day => dayData[day]);
          }
        }
        // console.log("getAllDay", days);
        return days;
      },
      getAllRecipes() {
        let allRecipes = [];
        if (this.mc_final_options_mon.length > 0) {
          allRecipes = allRecipes.concat(this.mc_final_options_mon);
        }
        if (this.mc_final_options_tue.length > 0) {
          allRecipes = allRecipes.concat(this.mc_final_options_tue);
        }
        if (this.mc_final_options_wed.length > 0) {
          allRecipes = allRecipes.concat(this.mc_final_options_wed);
        }
        if (this.mc_final_options_thu.length > 0) {
          allRecipes = allRecipes.concat(this.mc_final_options_thu);
        }
        if (this.mc_final_options_fri.length > 0) {
          allRecipes = allRecipes.concat(this.mc_final_options_fri);
        }
        if (this.mc_final_options_sat.length > 0) {
          allRecipes = allRecipes.concat(this.mc_final_options_sat);
        }
        if (this.mc_final_options_sun.length > 0) {
          allRecipes = allRecipes.concat(this.mc_final_options_sun);
        }
        return allRecipes;
      },
      weeklyAvg: function() {
        this.null_nutrient = this.$helpers.getUniqueNullNutritionKeysWeekCycle( this.getAllRecipes );

        this.override_components =this.$helpers.getUniqueOverrideComponentsWeekCycle( this.getAllRecipes );


        // console.log("null_nutrient", this.null_nutrient, this.getAllRecipes, this.$helpers.getUniqueNullNutritionKeysWeekCycle( this.getAllRecipes ));


        // `this` points to the vm instance
        let totalWeekDays = [];
        if (this.mc_daily_sum_prod_mon != null && Object.entries(this.mc_daily_sum_prod_mon).length > 0) {
          totalWeekDays.push(this.mc_daily_sum_prod_mon);
        }

        if (this.mc_daily_sum_prod_tue != null && Object.entries(this.mc_daily_sum_prod_tue).length > 0) {
          totalWeekDays.push(this.mc_daily_sum_prod_tue);
        }

        if (this.mc_daily_sum_prod_wed != null && Object.entries(this.mc_daily_sum_prod_wed).length > 0) {
          totalWeekDays.push(this.mc_daily_sum_prod_wed);
        }
        if (this.mc_daily_sum_prod_thu != null && Object.entries(this.mc_daily_sum_prod_thu).length > 0) {
          totalWeekDays.push(this.mc_daily_sum_prod_thu);
        }
        if (this.mc_daily_sum_prod_fri != null && Object.entries(this.mc_daily_sum_prod_fri).length > 0) {
          totalWeekDays.push(this.mc_daily_sum_prod_fri);
        }
        if (this.mc_daily_sum_prod_sat != null && Object.entries(this.mc_daily_sum_prod_sat).length > 0) {
          totalWeekDays.push(this.mc_daily_sum_prod_sat);
        }
        return this.$helpers.getWeeklyAvgWithBplBase(totalWeekDays, [this.mc_final_options_mon, this.mc_final_options_tue, this.mc_final_options_wed, this.mc_final_options_thu, this.mc_final_options_fri, this.mc_final_options_sat, this.mc_final_options_sun], this.todal_days, this.$page.props.serve_logic);
      },

      menucycle() {
        return {
          mc_id: null,
          mc_name: this.form.mc_name,
          meal_type_id: this.form.meal_type_id,
          age_grade_id: this.form.age_grade_id,
          days_id: this.form.days_id,
          guideline_id: this.form.guideline_id,
        }
      }
    },

    mounted() {

      if (this.selected_mealtype != null) {
        this.form.meal_type_id = this.selected_mealtype;
        this.form.mealtype = this.selected_mealtype;
      }
      if (this.selected_agerange != null) {
        this.form.age_grade_id = this.selected_agerange;
        this.form.agerange = this.selected_agerange;
      }
      if (this.selected_days != null) {
        this.form.days_id = this.selected_days;
        this.form.days = this.selected_days;
      }

      if (!this.is_fav_show) {
        this.form.mc_name = this.menuName;
      }

      this.updateGuidelineValues();
      this.getDefaultTag();
    },

    methods: {

      autoSelectInputOnClick(event) {
        if (event.target.tagName.toLowerCase() === 'input') {
          event.target.select();
        }
      },

      // logs: function(){
      //   alert('oksss')
      // },
      onDragStart() {
        // Function to be called when drag starts
        // console.log('Drag start:');
        // this.mc_final_options_tue['forlenth'] = 1;
        // this.dgragDropTrueFalse = true;
        // alert('drag start');
      },

      onDragEnd() {
        // Function to be called when drag ends
        console.log('Drag end:', );
      },


      handleDrag(event, day) {
        if (day == 1) {
          this.sortArrays(this.mc_final_options_mon);
          // this.mc_daily_sum_prod_mon = this.$helpers.getDayMinimumeValue(this.mc_final_options_mon);
          this.totalPlannedNumber('mon');
        } else if (day == 2) {
          this.sortArrays(this.mc_final_options_tue);
          // this.mc_daily_sum_prod_tue = this.$helpers.getDayMinimumeValue(this.mc_final_options_tue);
          this.totalPlannedNumber('tue');
        } else if (day == 3) {
          this.sortArrays(this.mc_final_options_wed);
          // this.mc_daily_sum_prod_wed= this.$helpers.getDayMinimumeValue(this.mc_final_options_wed);
          this.totalPlannedNumber('wed');

        } else if (day == 4) {
          this.sortArrays(this.mc_final_options_thu);
          // this.mc_daily_sum_prod_thu = this.$helpers.getDayMinimumeValue(this.mc_final_options_thu);
          this.totalPlannedNumber('thu');

        } else if (day == 5) {
          this.sortArrays(this.mc_final_options_fri);
          // this.mc_daily_sum_prod_fri = this.$helpers.getDayMinimumeValue(this.mc_final_options_fri);
          this.totalPlannedNumber('fri');
        } else if (day == 6) {
          this.sortArrays(this.mc_final_options_sat);
          // this.mc_daily_sum_prod_sat = this.$helpers.getDayMinimumeValue(this.mc_final_options_sat);
          this.totalPlannedNumber('sat');

        } else if (day == 7) {
          this.sortArrays(this.mc_final_options_sun);
          // this.mc_daily_sum_prod_sun = this.$helpers.getDayMinimumeValue(this.mc_final_options_sun);
          this.totalPlannedNumber('sun');
        }
      },


      //     handleDrag(event, day) {
      //     const dailySumProd = [
      //       null,
      //       this.mc_daily_sum_prod_mon,
      //       this.mc_daily_sum_prod_tue,
      //       this.mc_daily_sum_prod_wed,
      //       this.mc_daily_sum_prod_thu,
      //       this.mc_daily_sum_prod_fri,
      //       this.mc_daily_sum_prod_sat,
      //       this.mc_daily_sum_prod_sun
      //     ];

      //     dailySumProd[day] = this.$helpers.getDayMinimumeValue(this[`mc_final_options_${this.getDayName(day)}`]);

      //     // Update the individual variables if necessary (optional)
      //     [this.mc_daily_sum_prod_mon, this.mc_daily_sum_prod_tue, this.mc_daily_sum_prod_wed, this.mc_daily_sum_prod_thu, this.mc_daily_sum_prod_fri, this.mc_daily_sum_prod_sat, this.mc_daily_sum_prod_sun] = dailySumProd.slice(1);

      //     // If you don't need the individual variables, you can remove the above line.

      //     // If you need to access a specific day's value, you can do so using dailySumProd[day].
      //   },

      //   getDayName(day) {
      //     const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
      //     return days[day - 1];
      //   },


      showWarningHover(dayAvg, prod) {
        console.log("dayAvg", dayAvg);
        let gline = this.guideline_data;
        let returnText = [];
        for (let i = 0; i < this.datas.length; i++) {
          let gValid = this.$helpers.checkGuildLineVals(gline[this.datas[i]['min']], gline[this.datas[i]['max']], parseFloat(dayAvg[this.datas[i]['name']]), this.datas[i]['type']);
          if (gValid == 'red') {
            if (this.datas[i]['name'] === 'sugar') {
              returnText.push('Total Sugar' + ': ' + this.$helpers.nearestValue(parseFloat(dayAvg[this.datas[i]['name']])) + ', Min: ' + this.$helpers.nearestValue(gline[this.datas[i]['min']]) + ', Max: ' + this.$helpers.nearestValue(gline[this.datas[i]['max']]));
            } else {
              returnText.push(this.datas[i]['name'] + ': ' + this.$helpers.nearestValue(parseFloat(dayAvg[this.datas[i]['name']])) + ', Min: ' + this.$helpers.nearestValue(gline[this.datas[i]['min']]) + ', Max: ' + this.$helpers.nearestValue(gline[this.datas[i]['max']]));
            }


          }
        }
        returnText = this.$helpers.getAdditionalProducts(gline, prod, returnText, 'daily');
        // console.log('showWarningHover1', returnText);
        return returnText;
      },

      sortedArray: function(recipe_arrays) {
        // console.log("recipe_arrays", recipe_arrays);
        // return recipe_arrays;
        let a = _.orderBy(recipe_arrays, 'name', 'asc');
        a = _.orderBy(a, 'category_sort', 'asc');
        return a;
      },
      changeMonthYearModalOpen() {
        this.changeMonthYearModal = true;
      },

      changeDays() {
        let day_id = this.form.days_id;
        if (day_id != '') {
          let dd = this.days_data.find(x => x.id === day_id);
          console.log('dd', dd);
          if (dd) {
            this.todal_days = dd.total_days;
          } else {
            this.todal_days = 0;
          }
        } else {
          this.todal_days = 0;
        }
      },

      updateGuidelineValues() {
        if (this.form.meal_type_id && this.form.age_grade_id && this.form.days_id) {
          axios.post('/site-offering-get-guidelines', {
              meal_type: this.form.meal_type_id,
              age_range: this.form.age_grade_id,
              days: this.form.days_id,
            }).then((response) => {
              this.guidelines = response.data;
              //this.guideline_id= response.data[0]['id'];
            })
            .catch(error => console.error(error));
        }
        this.changeDays();
      },

      sortArrays(arrays) {
        return arrays;
        return _.orderBy(arrays, 'sort', 'asc');
      },

      // onGradeChangeSetupMealTypeMethod(e){
      //   let grade_range_val = e.target.value;
      //   axios.post('/menu-cycle-get-meal-types',{grade_range:grade_range_val})
      //       .then((response)=>{
      //          this.meal_types = response.data;
      //        })
      //       .catch(error => console.error(error));
      // },

      // getComponentPreviewSitesAsPerOffering(e){
      //   axios.post('/menu-cycle-get-offering-sites',{meal:e.target.value,grade_range:this.form.mc_grade_range})
      //                 .then((response)=>{
      //                    this.offering_site = response.data;
      //                  })
      //                 .catch(error => console.error(error));
      // },

      getComponentTotalsAsPerOffering(e) {
        var guideline_id = e.target.value;
        axios.post('/get-component-limits-from-guideline', {
            guideline: guideline_id
          })
          .then((response) => {
            this.guideline_data = response.data;
            //console.log(this.guideline_data);
          })
          .catch(error => console.error(error));
      },

      addRecipeOptionMenuCycle(day) {
        this.addRecipesOptionModal = true;

        this.day_number = day;
        if (day == 1) {
          this.option_number = this.mc_final_options_mon.length + 1;
        }
        if (day == 2) {
          this.option_number = this.mc_final_options_tue.length + 1;
        }
        if (day == 3) {
          this.option_number = this.mc_final_options_wed.length + 1;
        }
        if (day == 4) {
          this.option_number = this.mc_final_options_thu.length + 1;
        }
        if (day == 5) {
          this.option_number = this.mc_final_options_fri.length + 1;
        }
        if (day == 6) {
          this.option_number = this.mc_final_options_sat.length + 1;
        }
        if (day == 7) {
          this.option_number = this.mc_final_options_sun.length + 1;
        }
        this.name = "Option " + this.option_number;
      },

      changePlannedNumberValue(element, day) {
        element.planned_number = Math.abs(element.planned_number);
        if (element.planned_number < 0) {
          element.planned_number = 1;
        }
        this.totalPlannedNumber(day);
      },

      totalPlannedNumber(day) {

        const nutirtionsValues = ['FAT', 'CALS', 'calfat', 'satfat', 'transfat', 'polysatfat', 'monosatfat', 'cholesterol', 'SOD', 'potassium', 'CARB', 'fiber', 'sugar', 'PROT', 'vitamina', 'vitaminb6', 'vitaminb12', 'vitaminc', 'vitamind', 'vitamine', 'calcium', 'iron', 'magnesium', 'coblamin', 'thiamin', 'riboflavin', 'niacin', 'zinc', 'water', 'ash'];

        const dayOptions = this[`mc_final_options_${day}`];
        // console.log("before dayOptions", dayOptions);

        if (dayOptions.length > 0) {
          // console.log('before calculation dayOptions', dayOptions);
          let totalLength = 1;
          totalLength = dayOptions.reduce((total, option) => total + option.planned_number, 0);
          this[`total_planned_number_${day}`] = totalLength;
          // console.log("after add new total values dayOptionsday", dayOptions);

          dayOptions.forEach((option, index) => {
            let optionPlannedNumber = option.planned_number;
            let optionPercentage = (optionPlannedNumber / totalLength) * 100;
            if (option.recipes.length > 0) {
              option.recipes = this.sortedArray(option.recipes);
              // let total_val = {};
              // total_val = this.$helpers.getRecipeTotal(option.recipes, this.$page.props.serve_logic);

              option.new_total_val = this.$helpers.getRecipeTotal(option.recipes, this.$page.props.serve_logic);
              option.total_val = this.$helpers.getRecipeTotal(option.recipes, this.$page.props.serve_logic);

              // console.log("total_val", total_val);
              // option.total_val = total_val;

              for (const key in option.total_val) {
                if (nutirtionsValues.includes(key)) {
                  option.total_val[key] = (option.total_val[key] * optionPercentage) / 100;
                }
              }
            }
          });
        }
        this[`mc_daily_sum_prod_${day}`] = this.$helpers.getDayMinimumeValue(this[`mc_final_options_${day}`]);

        // console.log('mc_daily_sum_prod_', this[`mc_daily_sum_prod_${day}`]);

      },


      closeOptionsModal(mc_options_final_new) {

        let {
          attachedRecipes,
          optionPhoto,
          dayNumber,
          optionNumber,
          name,
          is_favorite,
          assembly_serving_free_text,
          assembly_serving,
          assembly_serving_unit,
          assembly_instructions,
          is_exclude_from_export,
          a_la_carte,
          tags
        } = mc_options_final_new;

        let optionName = name;

        this.addRecipesOptionModal = false;
        let total_val = {};

        console.log("attachedRecipes ", attachedRecipes, optionPhoto, dayNumber, optionNumber);
        if (attachedRecipes.length > 0) {
          total_val = this.$helpers.getRecipeTotal(attachedRecipes, this.$page.props.serve_logic);
          console.log("total_val", total_val);
        }

        let weeks = ['', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
        let day_of_week = weeks[dayNumber];
        console.log("day_of_week", day_of_week);

        var mc_options_final = {
          'recipes': attachedRecipes,
          'photo': optionPhoto,
          'sort': optionNumber,
          'name': optionName,
          'total_val': total_val,
          'is_favorite': is_favorite,
          'assembly_serving_free_text': assembly_serving_free_text,
          'assembly_serving': assembly_serving,
          'assembly_serving_unit': assembly_serving_unit,
          'assembly_instructions': assembly_instructions,
          'is_exclude_from_export': is_exclude_from_export,
          'a_la_carte': a_la_carte,
          'day_of_week': day_of_week,
          'planned_number': this.plannedNumber,
          'tags': tags,
        };


        if (dayNumber == 1 && attachedRecipes.length > 0) {

          console.log("total value for monday", total_val);

          this.mc_final_options_mon.push(mc_options_final);

          this.totalPlannedNumber('mon');

          console.log("mc_final_options_mon live", this.mc_final_options_mon);
          // console.log("getDayMinimumeValue", this.$helpers.getDayMinimumeValue(this.mc_final_options_mon));
          //console.log(this.mc_final_options_mon);

          attachedRecipes.forEach((value, index) => {
            this.mc_recipes_mon[value['id']] = value;
            this.mc_recipe_prefer_prod_mon = value['prefer_products'];

            this.mc_daily_sum_prod_mon_all_data.push(this.mc_recipe_prefer_prod_mon);
            //  this.mc_daily_sum_prod_mon = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_mon_all_data);

            this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_mon);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
            this.mc_recipe_prefer_prod_mon = [];
          });



        }
        if (dayNumber == 2 && attachedRecipes.length > 0) {
          console.log("mc_final_options_tue");
          this.mc_final_options_tue.push(mc_options_final);
          this.totalPlannedNumber('tue');

          // this.mc_daily_sum_prod_tue = this.$helpers.getDayMinimumeValue(this.mc_final_options_tue);

          //console.log(this.mc_final_options_tue);

          attachedRecipes.forEach((value, index) => {
            this.mc_recipes_tue[value['id']] = value;
            this.mc_recipe_prefer_prod_tue = value['prefer_products'];

            this.mc_daily_sum_prod_tue_all_data.push(this.mc_recipe_prefer_prod_tue);
            // this.mc_daily_sum_prod_tue = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_tue_all_data);

            this.avg_products_weekly_all_data[1].push(this.mc_recipe_prefer_prod_tue);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

            this.mc_recipe_prefer_prod_tue = [];

          });
        }
        if (dayNumber == 3 && attachedRecipes.length > 0) {

          this.mc_final_options_wed.push(mc_options_final);
          // this.mc_daily_sum_prod_wed = this.$helpers.getDayMinimumeValue(this.mc_final_options_wed);
          this.totalPlannedNumber('wed');


          attachedRecipes.forEach((value, index) => {
            this.mc_recipes_wed[value['id']] = value;
            this.mc_recipe_prefer_prod_wed = value['prefer_products'];

            this.mc_daily_sum_prod_wed_all_data.push(this.mc_recipe_prefer_prod_wed);
            // this.mc_daily_sum_prod_wed = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_wed_all_data);

            this.avg_products_weekly_all_data[2].push(this.mc_recipe_prefer_prod_wed);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

            this.mc_recipe_prefer_prod_wed = [];
          });


        }
        if (dayNumber == 4 && attachedRecipes.length > 0) {

          this.mc_final_options_thu.push(mc_options_final);
          // this.mc_daily_sum_prod_thu = this.$helpers.getDayMinimumeValue(this.mc_final_options_thu);
          this.totalPlannedNumber('thu');


          attachedRecipes.forEach((value, index) => {
            this.mc_recipes_thu[value['id']] = value;
            this.mc_recipe_prefer_prod_thu = value['prefer_products'];

            this.mc_daily_sum_prod_thu_all_data.push(this.mc_recipe_prefer_prod_thu);
            // this.mc_daily_sum_prod_thu = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_thu_all_data);

            this.avg_products_weekly_all_data[3].push(this.mc_recipe_prefer_prod_thu);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

            this.mc_recipe_prefer_prod_thu = [];

          });


        }
        if (dayNumber == 5 && attachedRecipes.length > 0) {

          this.mc_final_options_fri.push(mc_options_final);
          this.totalPlannedNumber('fri');

          // this.mc_daily_sum_prod_fri = this.$helpers.getDayMinimumeValue(this.mc_final_options_fri);

          attachedRecipes.forEach((value, index) => {
            this.mc_recipes_fri[value['id']] = value;
            this.mc_recipe_prefer_prod_fri = value['prefer_products'];

            this.mc_daily_sum_prod_fri_all_data.push(this.mc_recipe_prefer_prod_fri);
            // this.mc_daily_sum_prod_fri = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_fri_all_data);

            this.avg_products_weekly_all_data[4].push(this.mc_recipe_prefer_prod_fri);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

            this.mc_recipe_prefer_prod_fri = [];

          });

        }
        if (dayNumber == 6 && attachedRecipes.length > 0) {

          this.mc_final_options_sat.push(mc_options_final);
          this.totalPlannedNumber('sat');
          // this.mc_daily_sum_prod_sat = this.$helpers.getDayMinimumeValue(this.mc_final_options_sat);

          attachedRecipes.forEach((value, index) => {
            this.mc_recipes_sat[value['id']] = value;
            this.mc_recipe_prefer_prod_sat = value['prefer_products'];

            this.mc_daily_sum_prod_sat_all_data.push(this.mc_recipe_prefer_prod_sat);
            // this.mc_daily_sum_prod_sat = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_sat_all_data);

            this.avg_products_weekly_all_data[5].push(this.mc_recipe_prefer_prod_sat);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

            this.mc_recipe_prefer_prod_sat = [];

          });

        }
        if (dayNumber == 7 && attachedRecipes.length > 0) {

          this.mc_final_options_sun.push(mc_options_final);
          this.totalPlannedNumber('sun');
          // this.mc_daily_sum_prod_sun = this.$helpers.getDayMinimumeValue(this.mc_final_options_sun);

          attachedRecipes.forEach((value, index) => {
            this.mc_recipes_sun[value['id']] = value;
            this.mc_recipe_prefer_prod_sun = value['prefer_products'];

            this.mc_daily_sum_prod_sun_all_data.push(this.mc_recipe_prefer_prod_sun);
            // this.mc_daily_sum_prod_sun = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_sun_all_data);

            this.avg_products_weekly_all_data[6].push(this.mc_recipe_prefer_prod_sun);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

            this.mc_recipe_prefer_prod_sun = [];

          });
        }

      },

      // getWeeklyAvg(){

      // },

      addOptionEditScript(option_data, option_number, day) {
        console.log('option_dataoption_dataoption_data', option_data);

        this.addRecipesOptionModal = true;

        this.option_number = option_number + 1;
        this.day_number = day;

        //this.editOptionData = [];
        this.editOptionData = option_data;
        this.name = option_data.name;
        this.plannedNumber = option_data.planned_number;
      },

      addOptionCopyScript(option_data) {
        if (confirm("Are you sure you want to copy this option?")) {
          this.copied_option_data = JSON.parse(JSON.stringify(option_data));
          console.log('copied data start');
          console.log(this.copied_option_data);
          console.log('copied data end');
        }
      },

      addOptionPasteScript(total, day) {
        console.log('pasting data');
        if (this.copied_option_data != '') {
          if (confirm("Are you sure you want to paste here?")) {
            console.log("copied_option_data", this.copied_option_data);
            this.day_number = day;
            this.option_number = parseInt(total) + 1;
            let d = {
              attachedRecipes: this.copied_option_data.recipes,
              optionPhoto: this.copied_option_data.photo,
              dayNumber: day,
              optionNumber: this.option_number,
              name: this.copied_option_data.name,
              tags: this.copied_option_data.tags ?? []
            };
            this.closeOptionsModal(d);
          }
        } else {
          this.$toast.error('Error: Copy required first!');
        }

      },

      addOptionDuplicateScript(option_data, total, day) {
        if (confirm("Are you sure you want to duplicate this Option?")) {
          this.day_number = day;
          this.option_number = parseInt(total) + 1;
          option_data = JSON.parse(JSON.stringify(option_data));
          let d = {
            attachedRecipes: option_data.recipes,
            optionPhoto: option_data.photo,
            dayNumber: day,
            optionNumber: this.option_number,
            name: option_data.name,
            tags: option_data.tags ?? []
          };


          this.closeOptionsModal(d);
        }
      },

      addOptionDeleteScript(click_index, day) {
        let mc_option_id = "";
        if (confirm("Are you sure you want to delete this option?")) {
          if (day == 1) {

            mc_option_id = this.mc_final_options_mon[click_index].id;

            this.mc_final_options_mon.splice(click_index, 1);
            this.mc_daily_sum_prod_mon_all_data.splice(click_index, 1);

            // this.mc_daily_sum_prod_mon = this.$helpers.getDayMinimumeValue(this.mc_final_options_mon);

            // this.mc_daily_sum_prod_mon = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_mon_all_data);

            this.avg_products_weekly_all_data[0].splice(click_index, 1);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

            this.totalPlannedNumber('mon');
          }
          if (day == 2) {
            mc_option_id = this.mc_final_options_tue[click_index].id;
            this.mc_final_options_tue.splice(click_index, 1);

            this.mc_daily_sum_prod_tue_all_data.splice(click_index, 1);

            // this.mc_daily_sum_prod_tue = this.$helpers.getDayMinimumeValue(this.mc_final_options_tue);

            // this.mc_daily_sum_prod_tue = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_tue_all_data);

            this.avg_products_weekly_all_data[1].splice(click_index, 1);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
            this.totalPlannedNumber('tue');
          }
          if (day == 3) {
            mc_option_id = this.mc_final_options_wed[click_index].id;
            this.mc_final_options_wed.splice(click_index, 1);

            this.mc_daily_sum_prod_wed_all_data.splice(click_index, 1);

            // this.mc_daily_sum_prod_wed = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_wed_all_data);

            // this.mc_daily_sum_prod_wed = this.$helpers.getDayMinimumeValue(this.mc_final_options_wed);

            this.avg_products_weekly_all_data[2].splice(click_index, 1);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
            this.totalPlannedNumber('wed');
          }
          if (day == 4) {
            mc_option_id = this.mc_final_options_thu[click_index].id;
            this.mc_final_options_thu.splice(click_index, 1);

            this.mc_daily_sum_prod_thu_all_data.splice(click_index, 1);

            // this.mc_daily_sum_prod_thu = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_thu_all_data);

            // this.mc_daily_sum_prod_thu = this.$helpers.getDayMinimumeValue(this.mc_final_options_thu);

            this.avg_products_weekly_all_data[3].splice(click_index, 1);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
            this.totalPlannedNumber('thu');
          }
          if (day == 5) {
            mc_option_id = this.mc_final_options_fri[click_index].id;
            this.mc_final_options_fri.splice(click_index, 1);

            this.mc_daily_sum_prod_fri_all_data.splice(click_index, 1);

            // this.mc_daily_sum_prod_fri = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_fri_all_data);

            // this.mc_daily_sum_prod_fri = this.$helpers.getDayMinimumeValue(this.mc_final_options_fri);

            this.avg_products_weekly_all_data[4].splice(click_index, 1);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
            this.totalPlannedNumber('fri');

          }
          if (day == 6) {
            mc_option_id = this.mc_final_options_sat[click_index].id;
            this.mc_final_options_sat.splice(click_index, 1);

            this.mc_daily_sum_prod_sat_all_data.splice(click_index, 1);

            // this.mc_daily_sum_prod_sat = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_sat_all_data);

            // this.mc_daily_sum_prod_sat = this.$helpers.getDayMinimumeValue(this.mc_final_options_sat);

            this.avg_products_weekly_all_data[5].splice(click_index, 1);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
            this.totalPlannedNumber('sat');

          }
          if (day == 7) {
            mc_option_id = this.mc_final_options_sun[click_index].id;
            this.mc_final_options_sun.splice(click_index, 1);

            this.mc_daily_sum_prod_sun_all_data.splice(click_index, 1);
            this.mc_daily_sum_prod_sun = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_sun_all_data);

            // this.mc_daily_sum_prod_sun = this.$helpers.getDayMinimumeValue(this.mc_final_options_sun);

            this.avg_products_weekly_all_data[6].splice(click_index, 1);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
            this.totalPlannedNumber('sun');

          }

          if (mc_option_id && mc_option_id != "") {
            this.form.post(this.route('menu-cycle-option-delete', mc_option_id), {
              onSuccess: () => {
                this.$toast.success('MenuCycle option deleted successfully!');
              }
            });
          }
        }

      },

      saveAsTemplate() {
        this.form.is_template = 1;
        this.menucycle_add_save_script();
      },

      menucycle_add_save_script() {

        if (this.mc_final_options_mon.length > 0) {
          this.form.mc_options_mon = this.mc_final_options_mon;
        }
        if (this.mc_final_options_tue.length > 0) {
          this.form.mc_options_tue = this.mc_final_options_tue;
        }
        if (this.mc_final_options_wed.length > 0) {
          this.form.mc_options_wed = this.mc_final_options_wed;
        }
        if (this.mc_final_options_thu.length > 0) {
          this.form.mc_options_thu = this.mc_final_options_thu;
        }
        if (this.mc_final_options_fri.length > 0) {
          this.form.mc_options_fri = this.mc_final_options_fri;
        }
        if (this.mc_final_options_sat.length > 0) {
          this.form.mc_options_sat = this.mc_final_options_sat;
        }
        if (this.mc_final_options_sun.length > 0) {
          this.form.mc_options_sun = this.mc_final_options_sun;
        }

        // if(this.form.is_template == true){
        //   this.form.is_template = 1;
        // }
        console.log("this.form", this.form);
        if (this.form.weekNumber && !this.form.weekNumber !== this.form.weekNumber && this.form.weekNumber != '') {
          this.form.week_number = parseInt(this.form.weekNumber);
        }

        this.form.day_tags = JSON.parse(JSON.stringify(this.day_tags));

        console.log("this.form", this.form);

        this.form.post(this.route('menu-cycle-add-save'), {
          onSuccess: () => {
            this.$toast.success('Menu Week Added Successfully!');
          },
        });
      },

      // closeEditOptionsModal(attachedRecipes, optionPhoto, dayNumber, optionNumber, optionName, is_favorite, assembly_serving_free_text, assembly_serving, assembly_serving_unit, assembly_instructions, is_exclude_from_export, a_la_carte) {

      closeEditOptionsModal(mc_options_final_new) {

        let {
          attachedRecipes,
          optionPhoto,
          dayNumber,
          optionNumber,
          name,
          is_favorite,
          assembly_serving_free_text,
          assembly_serving,
          assembly_serving_unit,
          assembly_instructions,
          is_exclude_from_export,
          a_la_carte,
          tags
        } = mc_options_final_new;


        // console.log("during Edit", this.plannedNumber);

        this.addRecipesOptionModal = false;
        this.editOptionData = [];
        let index = optionNumber - 1;
        let total_val = {};
        // console.log("closeEditOptionsModal", attachedRecipes, optionPhoto, dayNumber, optionNumber, is_favorite);
        // if(attachedRecipes.length > 0){
        //   total_val = this.$helpers.getRecipeTotal(attachedRecipes);
        //   console.log("total_val", total_val);
        // }


        if (attachedRecipes.length > 0) {
          total_val = this.$helpers.getRecipeTotal(attachedRecipes, this.$page.props.serve_logic);
          console.log("total_val", total_val);
        }

        let weeks = ['', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
        let day_of_week = weeks[dayNumber];
        console.log("day_of_week", day_of_week);


        var mc_options_final = {
          'recipes': attachedRecipes,
          'photo': optionPhoto,
          'sort': optionNumber,
          'name': name,
          'total_val': total_val,
          'is_favorite': is_favorite,
          'assembly_serving_free_text': assembly_serving_free_text,
          'assembly_serving': assembly_serving,
          'assembly_serving_unit': assembly_serving_unit,
          'assembly_instructions': assembly_instructions,
          'is_exclude_from_export': is_exclude_from_export,
          'a_la_carte': a_la_carte,
          'day_of_week': day_of_week,
          'planned_number': this.plannedNumber,
          'tags': tags
        };
        this.plannedNumber = 1;

        console.log('In edit before update mc_final_options_mon vvvvvv', this.mc_final_options_mon);
        console.log('im here mc_options_final', mc_options_final);
        if (dayNumber == 1 && attachedRecipes.length > 0) {

          this.mc_final_options_mon[index] = mc_options_final;
          this.totalPlannedNumber('mon');
          // this.mc_daily_sum_prod_mon = this.$helpers.getDayMinimumeValue(this.mc_final_options_mon);

          attachedRecipes.forEach((value, key) => {
            this.mc_recipes_mon[value['id']] = value;
            if (value['prefer_products']) {
              this.mc_recipe_prefer_prod_mon = value['prefer_products'];
              // this.mc_daily_sum_prod_mon_all_data.push(this.mc_recipe_prefer_prod_mon);
              this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_mon);
            }
          });

          // this.mc_daily_sum_prod_mon = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_mon_all_data);

          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

          this.mc_recipe_prefer_prod_mon = [];

          console.log('In edit after update mc_final_options_mon vvvvvv', this.mc_final_options_mon);


        }
        if (dayNumber == 2 && attachedRecipes.length > 0) {

          this.mc_final_options_tue[index] = mc_options_final;
          this.totalPlannedNumber('tue');

          // this.mc_daily_sum_prod_tue = this.$helpers.getDayMinimumeValue(this.mc_final_options_tue);

          // this.mc_final_options_tue[index].recipes = attachedRecipes;
          // this.mc_final_options_tue[index].photo = optionPhoto;
          // this.mc_final_options_tue[index].sort = optionNumber;
          // this.mc_final_options_mon[index].name = optionName;

          attachedRecipes.forEach((value, key) => {

            this.mc_recipes_tue[value['id']] = value;

            if (value['prefer_products']) {
              this.mc_recipe_prefer_prod_tue = value['prefer_products'];
              this.mc_daily_sum_prod_tue_all_data.push(this.mc_recipe_prefer_prod_tue);
              this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_tue);
            }

          });

          // this.mc_daily_sum_prod_tue = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_tue_all_data);

          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

          this.mc_recipe_prefer_prod_tue = [];


        }
        if (dayNumber == 3 && attachedRecipes.length > 0) {

          this.mc_final_options_wed[index] = mc_options_final;
          // this.mc_daily_sum_prod_wed = this.$helpers.getDayMinimumeValue(this.mc_final_options_wed);
          this.totalPlannedNumber('wed');


          // this.mc_final_options_wed[index].recipes = attachedRecipes;
          // this.mc_final_options_wed[index].photo = optionPhoto;
          // this.mc_final_options_wed[index].sort = optionNumber;
          //   this.mc_final_options_mon[index].name = optionName;

          attachedRecipes.forEach((value, key) => {

            this.mc_recipes_wed[value['id']] = value;

            if (value['prefer_products']) {
              this.mc_recipe_prefer_prod_wed = value['prefer_products'];
              this.mc_daily_sum_prod_wed_all_data.push(this.mc_recipe_prefer_prod_wed);
              this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_wed);
            }

          });

          // this.mc_daily_sum_prod_wed = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_wed_all_data);

          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

          this.mc_recipe_prefer_prod_wed = [];
        }
        if (dayNumber == 4 && attachedRecipes.length > 0) {

          this.mc_final_options_thu[index] = mc_options_final;
          this.totalPlannedNumber('thu');

          // this.mc_daily_sum_prod_thu = this.$helpers.getDayMinimumeValue(this.mc_final_options_thu);

          // this.mc_final_options_thu[index].recipes = attachedRecipes;
          // this.mc_final_options_thu[index].photo = optionPhoto;
          // this.mc_final_options_thu[index].sort = optionNumber;
          //   this.mc_final_options_mon[index].name = optionName;

          attachedRecipes.forEach((value, key) => {

            this.mc_recipes_thu[value['id']] = value;

            if (value['prefer_products']) {
              this.mc_recipe_prefer_prod_thu = value['prefer_products'];
              this.mc_daily_sum_prod_thu_all_data.push(this.mc_recipe_prefer_prod_thu);
              this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_thu);
            }

          });

          // this.mc_daily_sum_prod_thu = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_thu_all_data);

          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

          this.mc_recipe_prefer_prod_thu = [];


        }
        if (dayNumber == 5 && attachedRecipes.length > 0) {

          this.mc_final_options_fri[index] = mc_options_final;
          this.totalPlannedNumber('fri');

          // this.mc_daily_sum_prod_fri = this.$helpers.getDayMinimumeValue(this.mc_final_options_fri);

          // this.mc_final_options_fri[index].recipes = attachedRecipes;
          // this.mc_final_options_fri[index].photo = optionPhoto;
          // this.mc_final_options_fri[index].sort = optionNumber;
          //   this.mc_final_options_mon[index].name = optionName;

          attachedRecipes.forEach((value, key) => {

            this.mc_recipes_fri[value['id']] = value;

            if (value['prefer_products']) {
              this.mc_recipe_prefer_prod_fri = value['prefer_products'];
              this.mc_daily_sum_prod_fri_all_data.push(this.mc_recipe_prefer_prod_fri);
              this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_fri);
            }

          });

          // this.mc_daily_sum_prod_fri = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_fri_all_data);

          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

          this.mc_recipe_prefer_prod_fri = [];


        }
        if (dayNumber == 6 && attachedRecipes.length > 0) {

          this.mc_final_options_sat[index] = mc_options_final;
          this.totalPlannedNumber('sat');

          // this.mc_daily_sum_prod_sat = this.$helpers.getDayMinimumeValue(this.mc_final_options_sat);

          // this.mc_final_options_sat[index].recipes = attachedRecipes;
          // this.mc_final_options_sat[index].photo = optionPhoto;
          // this.mc_final_options_sat[index].sort = optionNumber;
          //   this.mc_final_options_mon[index].name = optionName;

          attachedRecipes.forEach((value, key) => {

            this.mc_recipes_sat[value['id']] = value;

            if (value['prefer_products']) {
              this.mc_recipe_prefer_prod_sat = value['prefer_products'];
              this.mc_daily_sum_prod_sat_all_data.push(this.mc_recipe_prefer_prod_sat);
              this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_sat);
            }

          });

          // this.mc_daily_sum_prod_sat = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_sat_all_data);

          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

          this.mc_recipe_prefer_prod_sat = [];


        }
        if (dayNumber == 7 && attachedRecipes.length > 0) {

          this.mc_final_options_sun[index] = mc_options_final;
          this.totalPlannedNumber('sun');

          // this.mc_daily_sum_prod_sun = this.$helpers.getDayMinimumeValue(this.mc_final_options_sun);

          // this.mc_final_options_sun[index].recipes = attachedRecipes;
          // this.mc_final_options_sun[index].photo = optionPhoto;
          // this.mc_final_options_sun[index].sort = optionNumber;
          // this.mc_final_options_mon[index].name = optionName;

          attachedRecipes.forEach((value, key) => {

            this.mc_recipes_sun[value['id']] = value;

            if (value['prefer_products']) {
              this.mc_recipe_prefer_prod_sun = value['prefer_products'];
              this.mc_daily_sum_prod_sun_all_data.push(this.mc_recipe_prefer_prod_sun);
              this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_sun);
            }

          });

          // this.mc_daily_sum_prod_sun = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_sun_all_data);

          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

          this.mc_recipe_prefer_prod_sun = [];

        }

      },

      deleteOptionRecipeButton(recipeObj, element, dayName, click_index, day) {
        console.log(recipeObj, element.recipes, 'this is recipeObj');

        console.log('this is recipeObj check', recipeObj);
        console.log('this is element check', element);
        console.log('this is element dayName', dayName);

        if (confirm("Are you sure you want to delete this?")) {
          let $this = this;

          element.recipes = element.recipes.filter(
            (recipe) => recipe.id !== recipeObj.id
          );

          element.recipes.forEach((value, index) => {
            $this[`mc_recipes_${dayName}`][value['id']] = value;
            $this[`mc_recipe_prefer_prod_${dayName}`] = value['prefer_products'];

            $this[`mc_daily_sum_prod_${dayName}_all_data`].push($this[`mc_recipe_prefer_prod_${dayName}`]);
            //  this.mc_daily_sum_prod_mon = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_mon_all_data);

            $this.avg_products_weekly_all_data[0].push(this[`mc_recipe_prefer_prod_${dayName}`]);
            $this.mc_weekly_avg_prods = $this.$helpers.avg_products_week_setup($this.avg_products_weekly_all_data);

            $this[`mc_recipe_prefer_prod_${dayName}`] = [];
          });

          $this.totalPlannedNumber(dayName);

          console.log('lenght of mc_final_options_**************', element.recipes.length);
          if (element.recipes.length == 0) {
            this.addOptionDeleteScript(click_index, day);
          }
        }
      },

      replaceOptionRecipe(recipe, recipeIndex, elementArray, indexKey, dayName) {

        console.log('pop up model called', recipe);
        console.log('pop up model called recipeIndex', recipeIndex);
        console.log('pop up model called elementArray', elementArray);
        console.log('pop up model called indexKey', indexKey);
        console.log('pop up model called dayName', dayName);

        this.selectedRecipe = recipe;

        this.optionReplaceArray = {
          elementArray: elementArray,
          indexKey: indexKey,
          dayName: dayName,
          recipe: recipe,
          recipeIndex: recipeIndex
        };
        this.optionReplacePopup = true;
      },

      closeOptionReplacePopup() {
        this.optionReplacePopup = false;
        this.selectedRecipe = null;
        this.optionReplaceArray = null;
      },

      makeReplaceRecipe(newRecipe, is_whole_week) {
        newRecipe = JSON.parse(JSON.stringify(newRecipe));
        console.log('newRecipe', newRecipe, is_whole_week);
        console.log("optionReplaceArray", this.optionReplaceArray);
        let {
          elementArray,
          recipeIndex,
          indexKey,
          dayName,
          recipe
        } = this.optionReplaceArray;
        // this.replaceOptionRecipeWeek(newRecipe, recipe);

        elementArray = JSON.parse(JSON.stringify(elementArray));

        if (this.optionReplaceArray) {
          if (is_whole_week) {
            this.replaceOptionRecipeWeek(newRecipe, recipe);
          } else {
            // Sort recipes and replace the recipe at the specified index
            // elementArray.recipes = this.sortedArray(elementArray.recipes);
            newRecipe.option_component_id = elementArray.recipes[recipeIndex].option_component_id;
            elementArray.recipes = this.sortedArray(elementArray.recipes);
            elementArray.recipes[recipeIndex] = newRecipe;
            if (newRecipe.option_component_id) {
              elementArray.menu_cycle_day_option_components.forEach((value, index) => {
                if (value.id == newRecipe.option_component_id) {
                  value.recipe_id = newRecipe.id;
                }
                elementArray.menu_cycle_day_option_components[index] = value;
              });
            }


            // Update the final options for the specific day
            this[`mc_final_options_${dayName}`][indexKey] = elementArray;

            elementArray.recipes.forEach((value, index) => {

              // convert json to object
              this[`mc_recipes_${dayName}`] = JSON.parse(JSON.stringify(this[`mc_recipes_${dayName}`]));

              this[`mc_recipes_${dayName}`][value['id']] = value;
              this[`mc_recipe_prefer_prod_${dayName}`] = value['prefer_products'];

              // convert json to object
              this[`mc_daily_sum_prod_${dayName}_all_data`] = JSON.parse(JSON.stringify(this[`mc_daily_sum_prod_${dayName}_all_data`]));

              this[`mc_daily_sum_prod_${dayName}_all_data`].push(this[`mc_recipe_prefer_prod_${dayName}`]);
              //  this.mc_daily_sum_prod_mon = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_mon_all_data);


              // convert json to object
              this.avg_products_weekly_all_data = JSON.parse(JSON.stringify(this.avg_products_weekly_all_data));

              this.avg_products_weekly_all_data[0].push(this[`mc_recipe_prefer_prod_${dayName}`]);
              this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

              this[`mc_recipe_prefer_prod_${dayName}`] = [];
            });
            this.totalPlannedNumber(dayName);
          }

        }
      },



      addNewRecipe(elementArray, indexKey, dayName) {
        this.addNewRecipeArray = {
          elementArray: elementArray,
          indexKey: indexKey,
          dayName: dayName
        };
        this.newRecipePopup = true;
      },

      makeAddRecipe(newRecipe, addNewRecipeArray) {
        console.log('newRecipe', newRecipe);
        console.log("optionReplaceArray", this.optionReplaceArray);
        let {
          elementArray,
          indexKey,
          dayName
        } = addNewRecipeArray;
        // this.replaceOptionRecipeWeek(newRecipe, recipe);
        elementArray = JSON.parse(JSON.stringify(elementArray));


        if (addNewRecipeArray) {
          elementArray.recipes.push(newRecipe);

          elementArray.recipes = this.sortedArray(elementArray.recipes);

          this[`mc_final_options_${dayName}`] = JSON.parse(JSON.stringify(this[`mc_final_options_${dayName}`]));


          // Update the final options for the specific day
          this[`mc_final_options_${dayName}`][indexKey] = elementArray;

          elementArray.recipes.forEach((value, index) => {
            this[`mc_recipes_${dayName}`][value['id']] = value;
            this[`mc_recipe_prefer_prod_${dayName}`] = value['prefer_products'];

            this[`mc_daily_sum_prod_${dayName}_all_data`].push(this[`mc_recipe_prefer_prod_${dayName}`]);
            //  this.mc_daily_sum_prod_mon = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_mon_all_data);

            this.avg_products_weekly_all_data[0].push(this[`mc_recipe_prefer_prod_${dayName}`]);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

            this[`mc_recipe_prefer_prod_${dayName}`] = [];
          });
          this.totalPlannedNumber(dayName);

        }
      },




      closeNewRecipe() {
        this.addNewRecipeArray = null;
        this.newRecipePopup = false;
      },

      replaceOptionRecipeWeek(newRecipe, replaceableRecipe1) {
        let days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
        console.log("replaceOptionRecipeWeek in");

        days.forEach(day => {
          if (this[`mc_final_options_${day}`] && Object.keys(this[`mc_final_options_${day}`]).length > 0) {


            // console.log("replaceOptionRecipeWeek", day, this[`mc_final_options_${day}`]);

            this[`mc_final_options_${day}`] = JSON.parse(JSON.stringify(this[`mc_final_options_${day}`]));

            this[`mc_final_options_${day}`].forEach((dayData, index) => {
              if (dayData.recipes.length > 0) {
                console.log("replaceOptionRecipeWeek dayData final 1", dayData.recipes, dayData.menu_cycle_day_option_components);
                dayData.recipes.forEach((recipe, recipeIndex) => {

                  newRecipe = JSON.parse(JSON.stringify(newRecipe));
                  let replaceableRecipe = replaceableRecipe1;
                  // console.log("replaceOptionRecipeWeek dayData if", recipe.id == replaceableRecipe.id, recipe.id, replaceableRecipe.id);

                  if (recipe.id == replaceableRecipe.id) {
                    newRecipe.option_component_id = recipe.option_component_id;
                    // console.log("replaceOptionRecipeWeek", day, recipe, newRecipe);
                    dayData.recipes[recipeIndex] = newRecipe;

                    // console.log("replaceOptionRecipeWeek dayData if new", recipe.id == replaceableRecipe.id, recipe.id, replaceableRecipe.option_component_id);

                    if (newRecipe.option_component_id) {
                      dayData.menu_cycle_day_option_components.forEach((value, index) => {
                        if (value.id == newRecipe.option_component_id) {
                          value.recipe_id = newRecipe.id;
                          console.log("replaceOption RecipeWeek dayData change", day, value);
                        }
                        // console.log("replaceOption RecipeWeek dayData", day, dayData);
                        dayData.menu_cycle_day_option_components[index] = value;
                        // console.log("replaceOptionRecipeWeek dayData change", day, dayData);
                      });
                    }
                    // console.log("replaceOptionRecipeWeek dayData", day, dayData);
                  }

                });

                // console.log("replaceOptionRecipeWeek dayData final 2", dayData.recipes, dayData.menu_cycle_day_option_components);
                this[`mc_final_options_${day}`][index] = dayData;

                dayData.recipes.forEach((value, index) => {
                  // convert json to object
                  this[`mc_recipes_${day}`] = JSON.parse(JSON.stringify(this[`mc_recipes_${day}`]));

                  this[`mc_recipes_${day}`][value['id']] = value;
                  this[`mc_recipe_prefer_prod_${day}`] = value['prefer_products'];

                  // convert json to object
                  this[`mc_daily_sum_prod_${day}_all_data`] = JSON.parse(JSON.stringify(this[`mc_daily_sum_prod_${day}_all_data`]));

                  this[`mc_daily_sum_prod_${day}_all_data`].push(this[`mc_recipe_prefer_prod_${day}`]);

                  // convert json to object
                  this.avg_products_weekly_all_data = JSON.parse(JSON.stringify(this.avg_products_weekly_all_data));

                  this.avg_products_weekly_all_data[0].push(this[`mc_recipe_prefer_prod_${day}`]);
                  this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

                  this[`mc_recipe_prefer_prod_${day}`] = [];
                });
                this.totalPlannedNumber(day);
              }
            });
          }
        });
      },

      openTagPopup(element, eindex, day) {
        console.log('openTagPopup');
        this.dayTagsSync(day);


        this.isOpenTagModel = true;
        this.TagOptions['element'] = element;
        this.TagOptions['day'] = day;
        this.TagOptions['eindex'] = eindex;
        let tags = this.getAllTags(this['mc_final_options_' + day]);
        // this.TagOptions['tags'] = Array.from(tags.values());
        this.TagOptions['tags'] = this.day_tags[day];
        console.log('this.TagOptions', this.TagOptions);
      },
      closeTagPopup() {
        console.log('closeTagPopup');
        this.isOpenTagModel = false;
        this.TagOptions = [];
      },

      removeDayTag(tag) {
        let {
          element,
          day,
          eindex
        } = this.TagOptions;

        this['mc_final_options_' + day];

        const tagNameToRemove = tag.name.toLowerCase();

        this['mc_final_options_' + day].forEach((option) => {
        if (!option.tags) {
          option.tags = []; // Ensure it's an array
        }
        // Filter out the tag by name
        option.tags = option.tags.filter(tag => tag.name.toLowerCase() !== tagNameToRemove);
      });

      this['mc_final_options_' + day] = JSON.parse(JSON.stringify(this['mc_final_options_' + day]));


      this.day_tags[day] = JSON.parse(JSON.stringify(this.day_tags[day].filter(t => t.name.toLowerCase() !== tag.name.toLowerCase())));
      },

      dayTagsSync(day){
        let tags = this.getAllTags(this['mc_final_options_' + day]);

        tags = Array.isArray(tags) ? tags : [];

        let filteredArray = this.day_tags[day].filter(item =>
        (tags || []).some(ref => ref.name.toLowerCase === item.name.toLowerCase())
        );
        this.day_tags[day]  = filteredArray;

        
        // write a code for syncing tags on each day this.day_tags[day] 
        tags.forEach(tag => {
          if(!this.day_tags[day]){
            this.day_tags[day] = [];
          }
          // check if not exist then add
          if(!this.day_tags[day].some(t => t.name.toLowerCase() === tag.name.toLowerCase())){
            this.day_tags[day].push(tag);
          }
        })
      },
      handleTagSortable(allTags) {
        let {
          element,
          day,
          eindex
        } = this.TagOptions;
        this.day_tags[day] = JSON.parse(JSON.stringify(allTags)) ;
        this.day_tags = JSON.parse(JSON.stringify(this.day_tags));
      },

      attachTag(tagData) {
        let {
          element,
          day,
          eindex
        } = this.TagOptions;
        if (!element.tags) {
          element.tags = []; // Initialize as an empty array if undefined
        }

        if (element.tags.some(tag => tag.name.toLowerCase() == tagData.name.toLowerCase())) {
          element.tags = element.tags.filter(tag => tag.name.toLowerCase() !== tagData.name.toLowerCase());
          // element.tags.push(tagData);
        }
        element.tags.push(tagData);
        this.dayTagsSync(day);
        this.closeTagPopup();
      },
      attachRecipeToTag(element, tag) {
        if (!element.tags) {
          element.tags = []; // Initialize as an empty array if undefined
        }
        if (this.checkExistTag(element, tag)) {
          element.tags.push(tag);
        }
      },
      detachRecipeToTag(element, tagData) {
        element.tags = element.tags.filter(tag => tag.name.toLowerCase() !== tagData.name.toLowerCase());
      },
      checkExistTag(element, tagData) {
        if (!element.tags) {
          return true;
        }
        return !element.tags.some(tag => tag.name.toLowerCase() === tagData.name.toLowerCase());
      },
      // getRecipeArray(recipe_arrays, day) {

      //   let tags = this.getAllTags(day);
      //   let returnArray = {
      //     allRecipe: [],
      //     collapsedRecipe: []
      //   };
      //   if (tags.has(this.$page.props.default_tag)) {
      //     let recipes = this.getCommonRecipes(day);
      //     returnArray.allRecipe = recipe_arrays.filter(recipe => !recipes.some(r => r.id === recipe.id));
      //     returnArray.collapsedRecipe = recipe_arrays.filter(recipe => recipes.some(r => r.id === recipe.id));
      //   } else {
      //     returnArray.allRecipe = recipe_arrays;
      //     returnArray.collapsedRecipe = [];
      //   }
      //   return returnArray;

      // },

      getRecipeArray(recipe_arrays, day) {

let tags = this.getAllTags(day);
let returnArray = {
  allRecipe: [],
  collapsedRecipe: []
};

let recipes = this.getDefaultRecipes(day);

returnArray.allRecipe = recipe_arrays.filter(recipe => !recipes.some(r => r.id === recipe.id));
returnArray.collapsedRecipe = recipe_arrays.filter(recipe => recipes.some(r => r.id === recipe.id));

// if (tags.has(this.$page.props.default_tag)) {
//   let recipes = this.getCommonRecipes(day);
//   returnArray.allRecipe = recipe_arrays.filter(recipe => !recipes.some(r => r.id === recipe.id));
//   returnArray.collapsedRecipe = recipe_arrays.filter(recipe => recipes.some(r => r.id === recipe.id));
// } else {
//   returnArray.allRecipe = recipe_arrays;
//   returnArray.collapsedRecipe = [];
// }
return returnArray;
},
      getAllTags(elementDay) {
        const tagsMap = new Map();
        elementDay.forEach((option) => {
          if (!option.tags) {
            option.tags = []; // Initialize as an empty array if undefined
          }
          option.tags.forEach((tag) => {
            const tagName = tag.name.toLowerCase();
            if (!tagsMap.has(tagName)) {
              tagsMap.set(tagName, {
                name: tag.name,
                color: tag.color,
                is_default: tag.is_default
              });
            }
          });
        });
        return tagsMap;
      },
      getCommonRecipes(elementDay) {
        if (elementDay.length === 0) return [];

        // Initialize with the first option's recipe IDs
        let commonRecipeIds = new Set(elementDay[0].recipes.map(recipe => recipe.id));

        // Iterate over remaining options and find intersection
        elementDay.forEach((option) => {
          const currentRecipeIds = new Set(option.recipes.map(recipe => recipe.id));

          // Keep only recipes that are present in all options
          commonRecipeIds = new Set([...commonRecipeIds].filter(id => currentRecipeIds.has(id)));
        });

        // Retrieve full recipe objects
        const allRecipes = elementDay.flatMap(option => option.recipes);
        const commonRecipes = [...commonRecipeIds].map(id => allRecipes.find(recipe => recipe.id === id));

        return commonRecipes;
      },
      removeTag(element, index) {
        if (confirm('Are you sure you want to remove this tag?')) {
          element.tags.splice(index, 1);
        }

      },
      checkCollapse(id) {
        if (!this.collapseStates.has(id)) {
          this.collapseStates.set(id, false);
        }
        return this.collapseStates.get(id);
      },
      toggleCollapse(id) {
        this.collapseStates.set(id, !this.checkCollapse(id));
        return this.collapseStates.get(id);
      },
      replaceOptionData(day, index, data) {
        const key = 'mc_final_options_' + day;
        // Ensure the key exists before modifying || !this[key][index]
        if (!this[key]) {
          console.error(`Key ${key} or index ${index} does not exist.`);
          return;
        }

        // Iterate over all keys in data and assign them
        Object.keys(data).forEach(prop => {
          this[key][index][prop] = data[prop];
        });
      },

      checkRecipeExist(recipe, recipeArrays) {
        return recipeArrays.some(r => recipeArrays.some(ra => ra.id === recipe.id));
      },
      sendRecipe(mc_option_recipe, key, tag) {
        const days = key === 'all' ? ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] : [key];
        days.forEach(day => this.sendRecipeToDay(day, mc_option_recipe, tag));
      },
      sendRecipeToDay(day, recipe, tag) {
        const dayOptions = this[`mc_final_options_${day}`];

        if (!dayOptions || dayOptions.length === 0) return;

        dayOptions.forEach(dayData => {
          // console.log("replaceOptionRecipeWeek", day, dayData.name);

          dayData.tags = dayData.tags || []; // Ensure tags array exists
          if (!tag.is_default) {
            if (!dayData.tags.some(t => t.name.toLowerCase() === tag.name.toLowerCase())) {
              // console.log("replaceOptionRecipeWeek tag not found");
              dayData.tags.push(tag);
            }
          }


          dayData.recipes = dayData.recipes || []; // Ensure recipes array exists
          let existingRecipe = dayData.recipes.find(r => r.id === recipe.id);

          if (!existingRecipe) {
            // console.log("replaceOptionRecipeWeek recipe not found");
            dayData.recipes.push({
              ...recipe,
              tags: [tag]
            });
          } else {
            // console.log("replaceOptionRecipeWeek recipe found", existingRecipe, recipe.id);
            existingRecipe.tags = existingRecipe.tags || [];
            if (!existingRecipe.tags.some(t => t.name.toLowerCase() === tag.name.toLowerCase())) {
              existingRecipe.tags.push(tag);
            }
          }
        });

        this.dayTagsSync(day);
      },
      // sendToAllReceives(element) {
      //   axios
      //     .post("/tags/default")
      //     .then((response) => {
      //       this.attachRecipeToTag(element, response.data);
      //     })
      //     .catch((error) => console.error(error));
      // },
      sendToAllReceives(element) {
        if (!this.default_tag) {
          this.getDefaultTag(); // Ensure default_tag is fetched before proceeding
        }
        if (this.default_tag) {
          this.attachRecipeToTag(element, this.default_tag);
        }
      },
      getDefaultTag() {
        if (this.default_tag) return;

        axios
          .post("/tags/default")
          .then((response) => {
            this.default_tag = response.data;
            // this.attachRecipeToTag(element, response.data);
          })
          .catch((error) => console.error(error));
        // try {
        //   const response = await axios.post("/tags/default");
        //   this.default_tag = response.data;
        //   return response.data
        // } catch (error) {
        //   console.error(error);
        //   return null; // Prevent execution errors
        // }
      },
      getDefaultRecipes(elementDay) {
        const recipes = elementDay.flatMap(option => option.recipes);
        // Filter recipes with `is_default` tag
        const defaultRecipes = recipes.filter(recipe =>
          recipe.tags?.some(tag => tag.is_default) ?? false
        );
        // Remove duplicates using a Map (ensures unique recipes by ID)
        const uniqueRecipes = Array.from(
          new Map(defaultRecipes.map(recipe => [recipe.id, recipe])).values()
        );

        return uniqueRecipes;
      },
      attachRecipeToDefaultTag(elementDay, recipeId) {
        console.log('attachRecipeToDefaultTag', elementDay, recipeId.id);

        elementDay.forEach((option) => {
          option.recipes.forEach((recipe, rindex) => {
            if (!recipe.tags) {
              recipe.tags = []; // Initialize as an empty array if undefined
            }
            // console.log('attachRecipeToDefaultTag recipe.tags', recipe.id === recipeId.id, recipe.id, recipeId.id);
            if (recipe.id === recipeId.id) {
              if (!recipe.tags.some(tag => tag.is_default)) {
                recipe = JSON.parse(JSON.stringify(recipe));
                recipe.tags.push(this.default_tag);
                option.recipes[rindex] = recipe;
                console.log('attachRecipeToDefaultTag in if', elementDay, recipeId.id, this.default_tag, recipe.tags);
              }
            }
          });
        });
      },

      detachRecipeToDefaultTag(elementDay, recipeId) {
        // console.log('detachRecipeToDefaultTag');
        elementDay.forEach((option) => {
          option.recipes.forEach((recipe, rindex) => {
            if (!recipe.tags) {
              recipe.tags = []; // Initialize as an empty array if undefined
            }
            console.log('detachRecipeToDefaultTag', recipe.id === recipeId.id);
            if (recipe.id === recipeId.id) {
              recipe = JSON.parse(JSON.stringify(recipe));
              // console.log('detachRecipeToDefaultTag recipe.tags before ', recipe.tags);
              recipe.tags = recipe.tags.filter(tag => tag.name.toLowerCase() !== this.default_tag.name.toLowerCase());
              option.recipes[rindex] = recipe;
              // console.log('detachRecipeToDefaultTag recipe.tags ', recipe.tags);
            }
          });
        });
      },

    },
  };
</script>

<style>
  .cancel-background-color {
    background-color: #8b8b8b;
  }

  .placeholder-background-color {
    background-color: #f8f8f8;
  }

  .w-11\/12 {
    width: 95.666667%;
  }

  .mt-0-down {
    margin-top: -54px;
  }

  .bg-button-color {
    background-color: #cb0000;
  }

  .bg-button-color-green {
    background-color: #22af4b;
  }

  .bg-button-color-gray {
    background-color: #636363;
  }

  .bg-hard-grey {
    background-color: #f4f4f4;
  }

  .w-72-box-sizing {
    width: 330px;
    position: relative;
  }

  .text-color-first-li {
    color: #f7a53a;
    text-decoration: underline;
  }

  .icon-star-color {
    color: #f7a53a;
  }

  .th-heading-background {
    background-color: #f4f4f4;
  }

  .button-bg-color-wed {
    background-color: #cbcbcb;
  }

  .input-background {
    background-color: #f8f8f8;
  }

  .white-shadow-box {
    box-shadow: 0px 2px 5px #0000005e;
  }

  .min-w-min-button {
    min-height: 26px;
    min-width: 53px;
    line-height: 26px;
  }

  .validation_error_msg {
    font-weight: 400;
    margin: 6px 0 0 !important;
    color: red;
  }

  .smooth-dnd-container.vertical>.smooth-dnd-draggable-wrapper {
    overflow: visible;
  }

  .list-group {
    cursor: move;
  }
</style>